/* eslint-disable */
// This file is auto-generated by scripts/build-locales.mjs.
// Run `npm run locales:build` after updating app-store metadata or locale config.

export const localeOptions = [
  {
    "code": "en",
    "label": "English",
    "dir": "ltr"
  },
  {
    "code": "es",
    "label": "Español",
    "dir": "ltr"
  },
  {
    "code": "ru",
    "label": "Русский",
    "dir": "ltr"
  },
  {
    "code": "uk",
    "label": "Українська",
    "dir": "ltr"
  },
  {
    "code": "fr",
    "label": "Français",
    "dir": "ltr"
  },
  {
    "code": "de",
    "label": "Deutsch",
    "dir": "ltr"
  },
  {
    "code": "it",
    "label": "Italiano",
    "dir": "ltr"
  },
  {
    "code": "pt-BR",
    "label": "Português (Brasil)",
    "dir": "ltr"
  },
  {
    "code": "pl",
    "label": "Polski",
    "dir": "ltr"
  },
  {
    "code": "nl",
    "label": "Nederlands",
    "dir": "ltr"
  },
  {
    "code": "ar",
    "label": "العربية",
    "dir": "rtl"
  },
  {
    "code": "he",
    "label": "עברית",
    "dir": "rtl"
  },
  {
    "code": "hi",
    "label": "हिन्दी",
    "dir": "ltr"
  },
  {
    "code": "id",
    "label": "Bahasa Indonesia",
    "dir": "ltr"
  },
  {
    "code": "ja",
    "label": "日本語",
    "dir": "ltr"
  },
  {
    "code": "ko",
    "label": "한국어",
    "dir": "ltr"
  },
  {
    "code": "tr",
    "label": "Türkçe",
    "dir": "ltr"
  },
  {
    "code": "zh-CN",
    "label": "简体中文",
    "dir": "ltr"
  },
  {
    "code": "zh-TW",
    "label": "繁體中文",
    "dir": "ltr"
  }
] as const;

export const localeAliases = {
  "ar": "ar",
  "ar-sa": "ar",
  "de": "de",
  "de-at": "de",
  "de-de": "de",
  "en": "en",
  "en-au": "en",
  "en-ca": "en",
  "en-gb": "en",
  "en-in": "en",
  "en-sg": "en",
  "en-us": "en",
  "en-za": "en",
  "es": "es",
  "es-419": "es",
  "es-es": "es",
  "es-mx": "es",
  "es-us": "es",
  "fr": "fr",
  "fr-ca": "fr",
  "fr-fr": "fr",
  "he": "he",
  "hi": "hi",
  "hi-in": "hi",
  "id": "id",
  "in": "id",
  "it": "it",
  "it-it": "it",
  "iw": "he",
  "ja": "ja",
  "ja-jp": "ja",
  "ko": "ko",
  "ko-kr": "ko",
  "nl": "nl",
  "nl-nl": "nl",
  "pl": "pl",
  "pl-pl": "pl",
  "pt": "pt-BR",
  "pt-br": "pt-BR",
  "pt-pt": "pt-BR",
  "ru": "ru",
  "ru-ru": "ru",
  "tr": "tr",
  "tr-tr": "tr",
  "uk": "uk",
  "zh": "zh-CN",
  "zh-cn": "zh-CN",
  "zh-hans": "zh-CN",
  "zh-hant": "zh-TW",
  "zh-hk": "zh-TW",
  "zh-mo": "zh-TW",
  "zh-sg": "zh-CN",
  "zh-tw": "zh-TW"
} as const;

export const resources = {
  "en": {
    "translation": {
      "meta": {
        "appName": "Vritti: Breathwork & Pranayama",
        "badge": "Custom Breathwork Sequences",
        "dir": "ltr"
      },
      "landing": {
        "heroTitle": "A calmer way to shape your breathing practice.",
        "featuresTitle": "Why Vritti",
        "galleryTitle": "Inside the app",
        "closingTitle": "Start your next practice with Vritti.",
        "languageLabel": "Language",
        "themeLabel": "Theme",
        "themeSystem": "Auto",
        "themeLight": "Light",
        "themeDark": "Dark",
        "instituteName": "Institute of Eastern Methods of Rehabilitation",
        "footerNoteBefore": "Developed with methodological support from the ",
        "footerNoteAfter": ".",
        "appStoreBadgeAlt": "Download on the App Store",
        "googlePlayBadgeAlt": "Get it on Google Play"
      },
      "freediving": {
        "metaTitle": "Vritti for Freediving | Dry Apnea Practice App",
        "metaDescription": "Use Vritti for dry apnea practice on land. Build custom breath-hold and breathing sessions with flexible timing, cues, reminders, widgets, and saved routines.",
        "navLabel": "Freediving page",
        "navWhy": "Why it helps",
        "navScreenshots": "Screenshots",
        "navPrivacy": "Privacy",
        "mainPageCta": "See the main Vritti page",
        "heroKicker": "Freediving app for dry apnea practice",
        "heroTitle": "Structured dry apnea practice, made simple",
        "heroText": "Build custom breath-hold and breathing sessions with flexible timing, cues, reminders, widgets, and saved routines.",
        "heroNote": "Best suited for dry practice on land.",
        "whyKicker": "Dry practice structure",
        "whyTitle": "Why freedivers may find it useful",
        "whyText": "Vritti is a flexible apnea app and breath hold timer for breath-hold training on land, with tools for building repeatable dry apnea practice sessions.",
        "benefits": [
          "Create custom multi-stage sessions",
          "Adjust timing for your own dry practice structure",
          "Use sound, haptic, and visual cues",
          "Save routines and repeat them consistently",
          "Launch practice faster with widgets and reminders"
        ],
        "featuresKicker": "Feature set",
        "featuresTitle": "Built for flexible timing and repeatable routines",
        "screenshotCaptions": [
          "Build your own apnea session",
          "Dry breath-hold practice on land",
          "Flexible timing and cues",
          "Widgets and reminders for consistency",
          "Save routines for repeat practice",
          "Simple interface. Precise control."
        ],
        "designedTitle": "What Vritti is designed for",
        "designedText": "Vritti is a flexible breathing practice app that can be useful for dry breath-hold structure and breathing work on land.",
        "notTitle": "What it is not",
        "notText": "It is not a replacement for coaching, in-water supervision, buddy procedures, or freediving safety training.",
        "useKicker": "Practical use",
        "useTitle": "Possible uses",
        "useCases": [
          "Dry breath-hold timing",
          "Pre-practice calming breathwork",
          "Simple apnea session structure",
          "Personal breathing routines between training sessions"
        ],
        "trustKicker": "Trust",
        "trustTitle": "Simple and privacy-friendly",
        "trustPoints": [
          "Available on iPhone and Android",
          "Supports many interface languages",
          "No data collected, according to the App Store listing"
        ],
        "privacyLink": "Read the privacy policy",
        "finalKicker": "Free to try",
        "finalTitle": "Try Vritti for dry practice",
        "finalText": "If you want a simple way to structure breath-hold and breathing sessions on land, Vritti is free to try.",
        "safetyNote": "Use Vritti only for dry practice on land. It is not a freediving coach, safety system, in-water training app, or replacement for instruction and buddy procedures."
      },
      "support": {
        "metaTitle": "Support Vritti | Feedback & Ratings",
        "metaDescription": "Share feedback, rate Vritti, and support the free breathing practice app.",
        "title": "Support Vritti",
        "intro": "Vritti is completely free. If it helps your practice, the best ways to support it are a quick rating, honest feedback — or simply telling a friend.",
        "feedbackTitle": "Send feedback",
        "feedbackIntro": "Found a bug, missing a feature, or just want to say hi? We read every message.",
        "messageLabel": "Your message",
        "messagePlaceholder": "What's on your mind?",
        "emailLabel": "Reply email (optional)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Please enter a valid email address or leave the field empty.",
        "messageRequired": "Please write a message first.",
        "send": "Send feedback",
        "sending": "Sending…",
        "success": "Thank you! Your feedback has been sent.",
        "error": "Could not send feedback right now. Please try again in a few minutes.",
        "rateTitle": "Rate the app",
        "rateIntro": "Ratings help other people find Vritti. It takes less than a minute.",
        "rateAppStore": "Rate on the App Store",
        "rateGooglePlay": "Rate on Google Play",
        "donateTitle": "Leave a donation",
        "donateIntro": "If you'd like to support Vritti's development with a small gift, you can do so below. Everything stays optional — the app is and will remain free.",
        "donateButton": "Support on Ko-fi",
        "backHome": "Back to the main page"
      },
      "content": {
        "promoText": "Create custom breathwork, pranayama, or apnea sessions with sound, haptic, and visual cues, reminders, widgets, and easy sharing.",
        "summary": "Build custom breathwork, pranayama, and apnea sessions in minutes.",
        "details": "Combine multiple stages into one seamless flow, fine-tune timing, and use sound, haptic, and visual cues to stay focused.",
        "features": [
          "Build multi-stage breathing sequences",
          "Adjust timing, cues, sounds, and reminders",
          "Start quickly with ready-to-use modes",
          "Use widgets for faster access",
          "Share routines with students, clients, or friends",
          "Practice in a clean interface with clear guidance"
        ],
        "closing": "Whether you want a short calming reset, a more structured pranayama routine, or a personal apnea practice, Vritti gives you precise control without unnecessary complexity."
      }
    }
  },
  "es": {
    "translation": {
      "meta": {
        "appName": "Vritti",
        "badge": "Respiración y pranayama",
        "dir": "ltr"
      },
      "landing": {
        "heroTitle": "Una forma más serena de crear tu práctica de respiración.",
        "featuresTitle": "Por qué Vritti",
        "galleryTitle": "Dentro de la app",
        "closingTitle": "Empieza tu próxima práctica con Vritti.",
        "languageLabel": "Idioma",
        "themeLabel": "Tema",
        "themeSystem": "Auto",
        "themeLight": "Claro",
        "themeDark": "Oscuro",
        "instituteName": "Instituto de Métodos Orientales de Rehabilitación",
        "footerNoteBefore": "Desarrollada con apoyo metodológico del ",
        "footerNoteAfter": ".",
        "appStoreBadgeAlt": "Descargar en el App Store",
        "googlePlayBadgeAlt": "Disponible en Google Play"
      },
      "freediving": {
        "metaTitle": "Vritti para freediving | App de apnea en seco",
        "metaDescription": "Usa Vritti para la práctica de apnea en seco en tierra. Crea sesiones personalizadas de apnea y respiración con tiempos flexibles, señales, recordatorios, widgets y rutinas guardadas.",
        "navLabel": "Página de freediving",
        "navWhy": "Por qué ayuda",
        "navScreenshots": "Capturas",
        "navPrivacy": "Privacidad",
        "mainPageCta": "Ver la página principal de Vritti",
        "heroKicker": "App de freediving para apnea en seco",
        "heroTitle": "Práctica de apnea en seco estructurada y simple",
        "heroText": "Crea sesiones personalizadas de apnea y respiración con tiempos flexibles, señales, recordatorios, widgets y rutinas guardadas.",
        "heroNote": "Más adecuada para práctica en seco en tierra.",
        "whyKicker": "Estructura para práctica en seco",
        "whyTitle": "Por qué puede ser útil para freedivers",
        "whyText": "Vritti es una app flexible de apnea y temporizador de apnea para entrenamiento de apnea en tierra, con herramientas para crear sesiones repetibles de práctica en seco.",
        "benefits": [
          "Crea sesiones personalizadas de varias fases",
          "Ajusta los tiempos a tu propia estructura de práctica en seco",
          "Usa señales sonoras, hápticas y visuales",
          "Guarda rutinas y repítelas con constancia",
          "Inicia la práctica más rápido con widgets y recordatorios"
        ],
        "featuresKicker": "Funciones",
        "featuresTitle": "Tiempos flexibles y rutinas repetibles",
        "screenshotCaptions": [
          "Crea tu propia sesión de apnea",
          "Práctica de apnea en seco en tierra",
          "Tiempos y señales flexibles",
          "Widgets y recordatorios para la constancia",
          "Guarda rutinas para repetir la práctica",
          "Interfaz simple. Control preciso."
        ],
        "designedTitle": "Para qué está diseñado Vritti",
        "designedText": "Vritti es una app flexible de práctica respiratoria que puede ser útil para estructurar apnea en seco y trabajo respiratorio en tierra.",
        "notTitle": "Lo que no es",
        "notText": "No sustituye al coaching, la supervisión en el agua, los procedimientos con compañero ni la formación de seguridad en freediving.",
        "useKicker": "Uso práctico",
        "useTitle": "Usos posibles",
        "useCases": [
          "Temporizador de apnea en seco",
          "Respiración calmante antes de la práctica",
          "Estructura simple para sesiones de apnea",
          "Rutinas personales de respiración entre entrenamientos"
        ],
        "trustKicker": "Confianza",
        "trustTitle": "Simple y respetuosa con la privacidad",
        "trustPoints": [
          "Disponible en iPhone y Android",
          "Admite muchos idiomas de interfaz",
          "No recopila datos, según la ficha del App Store"
        ],
        "privacyLink": "Leer la política de privacidad",
        "finalKicker": "Gratis para probar",
        "finalTitle": "Prueba Vritti para práctica en seco",
        "finalText": "Si quieres una forma simple de estructurar sesiones de apnea y respiración en tierra, puedes probar Vritti gratis.",
        "safetyNote": "Usa Vritti solo para práctica en seco en tierra. No es un entrenador de freediving, un sistema de seguridad, una app de entrenamiento en el agua ni un sustituto de la instrucción y los procedimientos con compañero."
      },
      "support": {
        "metaTitle": "Support Vritti | Feedback & Ratings",
        "metaDescription": "Share feedback, rate Vritti, and support the free breathing practice app.",
        "title": "Support Vritti",
        "intro": "Vritti is completely free. If it helps your practice, the best ways to support it are a quick rating, honest feedback — or simply telling a friend.",
        "feedbackTitle": "Send feedback",
        "feedbackIntro": "Found a bug, missing a feature, or just want to say hi? We read every message.",
        "messageLabel": "Your message",
        "messagePlaceholder": "What's on your mind?",
        "emailLabel": "Reply email (optional)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Please enter a valid email address or leave the field empty.",
        "messageRequired": "Please write a message first.",
        "send": "Send feedback",
        "sending": "Sending…",
        "success": "Thank you! Your feedback has been sent.",
        "error": "Could not send feedback right now. Please try again in a few minutes.",
        "rateTitle": "Rate the app",
        "rateIntro": "Ratings help other people find Vritti. It takes less than a minute.",
        "rateAppStore": "Rate on the App Store",
        "rateGooglePlay": "Rate on Google Play",
        "donateTitle": "Leave a donation",
        "donateIntro": "If you'd like to support Vritti's development with a small gift, you can do so below. Everything stays optional — the app is and will remain free.",
        "donateButton": "Support on Ko-fi",
        "backHome": "Back to the main page"
      },
      "content": {
        "promoText": "Crea flujos de respiración personalizados, combina etapas en una sola sesión fluida, ajusta sonidos y señales, y comparte rutinas con otras personas.",
        "summary": "Vritti convierte la práctica de la respiración en un ritual diario sencillo para encontrar calma, enfoque y equilibrio.",
        "details": "Crea tu propio flujo combinando ejercicios de respiración, bloques de meditación y sesiones rítmicas en una sola práctica fluida. Empieza con sesiones recomendadas, ajusta tiempos y configuraciones a tu manera, elige los sonidos que mejor encajen contigo y comparte tus prácticas con otras personas. Guarda etapas personalizadas como plantillas para crear nuevas prácticas más rápido.",
        "features": [
          "Crea y reproduce secuencias personalizadas de práctica",
          "Ajusta cada práctica con configuraciones flexibles",
          "Guarda etapas personalizadas como plantillas para crear nuevas prácticas más rápido",
          "Empieza rápido con sesiones listas para usar y recomendadas",
          "Disfruta de una experiencia más inmersiva con sonidos, señales visuales y guía háptica",
          "Comparte tus prácticas con amigos, alumnos o clientes",
          "Practica en una interfaz limpia e intuitiva"
        ],
        "closing": "Para principiantes y practicantes con experiencia.\nDesarrollada con apoyo metodológico del Instituto de Métodos Orientales de Rehabilitación."
      }
    }
  },
  "ru": {
    "translation": {
      "meta": {
        "appName": "Вритти",
        "badge": "Дыхание и пранаяма",
        "dir": "ltr"
      },
      "landing": {
        "heroTitle": "Быстрый способ выстроить свою дыхательную практику.",
        "featuresTitle": "Почему Vritti",
        "galleryTitle": "Внутри приложения",
        "closingTitle": "Начните следующую практику с Vritti.",
        "languageLabel": "Язык",
        "themeLabel": "Тема",
        "themeSystem": "Авто",
        "themeLight": "Светлая",
        "themeDark": "Тёмная",
        "instituteName": "Института Восточных Методов Реабилитации",
        "footerNoteBefore": "Разработано при методической поддержке ",
        "footerNoteAfter": ".",
        "appStoreBadgeAlt": "Скачать в App Store",
        "googlePlayBadgeAlt": "Открыть в Google Play"
      },
      "freediving": {
        "metaTitle": "Vritti для фридайвинга | Приложение для сухой апноэ-практики",
        "metaDescription": "Используйте Vritti для сухой апноэ-практики на суше. Создавайте собственные задержки дыхания и дыхательные сессии с гибким таймингом, сигналами, напоминаниями, виджетами и сохранёнными практиками.",
        "navLabel": "Страница для фридайвинга",
        "navWhy": "Зачем это нужно",
        "navScreenshots": "Скриншоты",
        "navPrivacy": "Конфиденциальность",
        "mainPageCta": "Открыть главную страницу Vritti",
        "heroKicker": "Приложение для сухой апноэ-практики",
        "heroTitle": "Структурированная сухая апноэ-практика без лишней сложности",
        "heroText": "Создавайте собственные задержки дыхания и дыхательные сессии с гибким таймингом, сигналами, напоминаниями, виджетами и сохранёнными практиками.",
        "heroNote": "Лучше всего подходит для сухой практики на суше.",
        "whyKicker": "Структура сухой практики",
        "whyTitle": "Почему это может быть полезно фридайверам",
        "whyText": "Vritti — гибкое приложение для апноэ и таймер задержки дыхания для тренировок на суше, с инструментами для повторяемых сухих практик.",
        "benefits": [
          "Создавайте многоэтапные сессии",
          "Настраивайте тайминг под свою структуру сухой практики",
          "Используйте звуковые, вибрационные и визуальные сигналы",
          "Сохраняйте практики и повторяйте их регулярно",
          "Запускайте практику быстрее с виджетами и напоминаниями"
        ],
        "featuresKicker": "Возможности",
        "featuresTitle": "Гибкий тайминг и повторяемые практики",
        "screenshotCaptions": [
          "Соберите свою апноэ-сессию",
          "Сухая практика задержки дыхания на суше",
          "Гибкий тайминг и сигналы",
          "Виджеты и напоминания для регулярности",
          "Сохраняйте практики для повторения",
          "Простой интерфейс. Точный контроль."
        ],
        "designedTitle": "Для чего предназначен Vritti",
        "designedText": "Vritti — гибкое приложение для дыхательных практик, которое может быть полезно для структуры сухих задержек дыхания и дыхательной работы на суше.",
        "notTitle": "Чем он не является",
        "notText": "Это не замена тренеру, наблюдению в воде, процедурам с напарником или обучению безопасности во фридайвинге.",
        "useKicker": "Практическое применение",
        "useTitle": "Возможные сценарии",
        "useCases": [
          "Тайминг сухой задержки дыхания",
          "Успокаивающая дыхательная практика перед занятием",
          "Простая структура апноэ-сессии",
          "Личные дыхательные практики между тренировками"
        ],
        "trustKicker": "Доверие",
        "trustTitle": "Просто и дружелюбно к приватности",
        "trustPoints": [
          "Доступно на iPhone и Android",
          "Поддерживает много языков интерфейса",
          "Согласно странице App Store, данные не собираются"
        ],
        "privacyLink": "Прочитать политику конфиденциальности",
        "finalKicker": "Можно попробовать бесплатно",
        "finalTitle": "Попробуйте Vritti для сухой практики",
        "finalText": "Если вам нужен простой способ структурировать задержки дыхания и дыхательные сессии на суше, Vritti можно попробовать бесплатно.",
        "safetyNote": "Используйте Vritti только для сухой практики на суше. Это не тренер по фридайвингу, не система безопасности, не приложение для тренировок в воде и не замена обучению и процедурам с напарником."
      },
      "support": {
        "metaTitle": "Поддержать Vritti | Отзывы и оценки",
        "metaDescription": "Оставьте отзыв, оцените Vritti и поддержите бесплатное приложение для дыхательных практик.",
        "title": "Поддержать Vritti",
        "intro": "Vritti — полностью бесплатное приложение. Если оно помогает вашей практике, лучшая поддержка — оценка в сторе, честный отзыв или рекомендация друзьям.",
        "feedbackTitle": "Написать нам",
        "feedbackIntro": "Нашли ошибку, не хватает функции или просто хотите сказать спасибо? Мы читаем каждое сообщение.",
        "messageLabel": "Ваше сообщение",
        "messagePlaceholder": "Что у вас на уме?",
        "emailLabel": "Email для ответа (необязательно)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Введите корректный email или оставьте поле пустым.",
        "messageRequired": "Сначала напишите сообщение.",
        "send": "Отправить",
        "sending": "Отправляем…",
        "success": "Спасибо! Ваше сообщение отправлено.",
        "error": "Не получилось отправить сообщение. Попробуйте ещё раз через несколько минут.",
        "rateTitle": "Оценить приложение",
        "rateIntro": "Оценки помогают другим людям найти Vritti. Это занимает меньше минуты.",
        "rateAppStore": "Оценить в App Store",
        "rateGooglePlay": "Оценить в Google Play",
        "donateTitle": "Поддержать разработку",
        "donateIntro": "Если хотите поддержать развитие Vritti небольшим подарком — это можно сделать ниже. Всё добровольно: приложение было и останется бесплатным.",
        "donateButton": "Поддержать на Ko-fi",
        "backHome": "Вернуться на главную"
      },
      "content": {
        "promoText": "Создавайте собственные дыхательные практики, объединяйте несколько этапов в одну плавную сессию, настраивайте звуки и сигналы и делитесь практиками с другими.",
        "summary": "Вритти превращает дыхательную практику в простой ежедневный ритуал для спокойствия, концентрации и восстановления.",
        "details": "Создавайте свои практики, объединяя дыхательные техники в одну полноценную тренировку. \nНачинайте с рекомендованных сессий, настраивайте время и параметры под себя, выбирайте подходящие звуки и делитесь своими практиками с другими. Сохраняйте свои этапы как шаблоны, чтобы быстрее собирать новые практики.",
        "features": [
          "Создавайте и запускайте собственные последовательности практик",
          "Гибко настраивайте каждую практику под себя",
          "Сохраняйте шаблоны, чтобы быстрее собирать новые практики",
          "Быстро начинайте с готовых и рекомендованных сессий",
          "Погружайтесь глубже с помощью звуков, визуальных и тактильных подсказок",
          "Делитесь практиками с друзьями, учениками или клиентами",
          "Практикуйте в понятном интерфейсе"
        ],
        "closing": "Подходит и новичкам, и опытным практикам.\nРазработано при методической поддержке Института Восточных Методов Реабилитации."
      }
    }
  },
  "uk": {
    "translation": {
      "meta": {
        "appName": "Vritti",
        "badge": "Дихання і пранаяма",
        "dir": "ltr"
      },
      "landing": {
        "heroTitle": "Спокійніший спосіб вибудувати власну дихальну практику.",
        "featuresTitle": "Чому Vritti",
        "galleryTitle": "Усередині застосунку",
        "closingTitle": "Почніть наступну практику з Vritti.",
        "languageLabel": "Мова",
        "themeLabel": "Тема",
        "themeSystem": "Авто",
        "themeLight": "Світла",
        "themeDark": "Темна",
        "instituteName": "Інституту Східних Методів Реабілітації",
        "footerNoteBefore": "Розроблено за методичної підтримки ",
        "footerNoteAfter": ".",
        "appStoreBadgeAlt": "Завантажити з App Store",
        "googlePlayBadgeAlt": "Відкрити у Google Play"
      },
      "freediving": {
        "metaTitle": "Vritti для фрідайвінгу | Застосунок для сухої апное-практики",
        "metaDescription": "Використовуйте Vritti для сухої апное-практики на суші. Створюйте власні сесії затримки дихання й дихальні практики з гнучким таймінгом, сигналами, нагадуваннями, віджетами та збереженими рутинами.",
        "navLabel": "Сторінка для фрідайвінгу",
        "navWhy": "Чому це корисно",
        "navScreenshots": "Скриншоти",
        "navPrivacy": "Приватність",
        "mainPageCta": "Перейти на головну сторінку Vritti",
        "heroKicker": "Застосунок для сухої апное-практики",
        "heroTitle": "Структурована суха апное-практика без зайвої складності",
        "heroText": "Створюйте власні сесії затримки дихання й дихальні практики з гнучким таймінгом, сигналами, нагадуваннями, віджетами та збереженими рутинами.",
        "heroNote": "Найкраще підходить для сухої практики на суші.",
        "whyKicker": "Структура сухої практики",
        "whyTitle": "Чому це може бути корисно фрідайверам",
        "whyText": "Vritti — гнучкий застосунок для апное й таймер затримки дихання для тренування на суші, з інструментами для повторюваних сухих практик.",
        "benefits": [
          "Створюйте власні багатоетапні сесії",
          "Налаштовуйте таймінг під свою структуру сухої практики",
          "Використовуйте звукові, тактильні й візуальні сигнали",
          "Зберігайте рутини й повторюйте їх регулярно",
          "Запускайте практику швидше з віджетами та нагадуваннями"
        ],
        "featuresKicker": "Можливості",
        "featuresTitle": "Гнучкий таймінг і повторювані рутини",
        "screenshotCaptions": [
          "Створіть власну апное-сесію",
          "Суха практика затримки дихання на суші",
          "Гнучкий таймінг і сигнали",
          "Віджети й нагадування для регулярності",
          "Зберігайте рутини для повторення",
          "Простий інтерфейс. Точний контроль."
        ],
        "designedTitle": "Для чого створений Vritti",
        "designedText": "Vritti — гнучкий застосунок для дихальних практик, який може бути корисним для структури сухої затримки дихання й дихальної роботи на суші.",
        "notTitle": "Чим він не є",
        "notText": "Він не замінює тренера, нагляд у воді, процедури з напарником або навчання безпеці у фрідайвінгу.",
        "useKicker": "Практичне використання",
        "useTitle": "Можливі сценарії",
        "useCases": [
          "Таймінг сухої затримки дихання",
          "Заспокійлива дихальна практика перед заняттям",
          "Проста структура апное-сесії",
          "Особисті дихальні рутини між тренуваннями"
        ],
        "trustKicker": "Довіра",
        "trustTitle": "Просто й дружньо до приватності",
        "trustPoints": [
          "Доступно на iPhone та Android",
          "Підтримує багато мов інтерфейсу",
          "Згідно зі сторінкою App Store, дані не збираються"
        ],
        "privacyLink": "Прочитати політику приватності",
        "finalKicker": "Можна спробувати безкоштовно",
        "finalTitle": "Спробуйте Vritti для сухої практики",
        "finalText": "Якщо вам потрібен простий спосіб структурувати сесії затримки дихання й дихальні практики на суші, Vritti можна спробувати безкоштовно.",
        "safetyNote": "Використовуйте Vritti лише для сухої практики на суші. Це не тренер з фрідайвінгу, не система безпеки, не застосунок для тренувань у воді й не заміна інструктажу та процедур із напарником."
      },
      "support": {
        "metaTitle": "Support Vritti | Feedback & Ratings",
        "metaDescription": "Share feedback, rate Vritti, and support the free breathing practice app.",
        "title": "Support Vritti",
        "intro": "Vritti is completely free. If it helps your practice, the best ways to support it are a quick rating, honest feedback — or simply telling a friend.",
        "feedbackTitle": "Send feedback",
        "feedbackIntro": "Found a bug, missing a feature, or just want to say hi? We read every message.",
        "messageLabel": "Your message",
        "messagePlaceholder": "What's on your mind?",
        "emailLabel": "Reply email (optional)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Please enter a valid email address or leave the field empty.",
        "messageRequired": "Please write a message first.",
        "send": "Send feedback",
        "sending": "Sending…",
        "success": "Thank you! Your feedback has been sent.",
        "error": "Could not send feedback right now. Please try again in a few minutes.",
        "rateTitle": "Rate the app",
        "rateIntro": "Ratings help other people find Vritti. It takes less than a minute.",
        "rateAppStore": "Rate on the App Store",
        "rateGooglePlay": "Rate on Google Play",
        "donateTitle": "Leave a donation",
        "donateIntro": "If you'd like to support Vritti's development with a small gift, you can do so below. Everything stays optional — the app is and will remain free.",
        "donateButton": "Support on Ko-fi",
        "backHome": "Back to the main page"
      },
      "content": {
        "promoText": "Створюйте власний хід дихальної практики, поєднуйте кілька етапів в одну плавну сесію, налаштовуйте звуки й сигнали та діліться практиками з іншими.",
        "summary": "Vritti перетворює дихальну практику на простий щоденний ритуал для спокою, концентрації та відновлення.",
        "details": "Створюйте власний потік, поєднуючи дихальні вправи, медитаційні блоки та ритмічні сесії в одну плавну практику. Починайте з рекомендованих сесій, гнучко налаштовуйте час і параметри, обирайте звуки під свій настрій і діліться практиками з іншими. Зберігайте власні етапи як шаблони, щоб швидше створювати нові практики.",
        "features": [
          "Створюйте й запускайте власні послідовності практик",
          "Гнучко налаштовуйте кожну практику під себе",
          "Зберігайте власні етапи як шаблони, щоб швидше створювати нові практики",
          "Швидко починайте з готових і рекомендованих сесій",
          "Занурюйтесь глибше завдяки звукам, візуальним і тактильним підказкам",
          "Діліться практиками з друзями, учнями або клієнтами",
          "Практикуйте в чистому й зрозумілому інтерфейсі"
        ],
        "closing": "Підходить і новачкам, і досвідченим практикам.\nРозроблено за методичної підтримки Інституту Східних Методів Реабілітації."
      }
    }
  },
  "fr": {
    "translation": {
      "meta": {
        "appName": "Vritti",
        "badge": "Respiration & pranayama",
        "dir": "ltr"
      },
      "landing": {
        "heroTitle": "Une façon plus sereine de construire votre pratique respiratoire.",
        "featuresTitle": "Pourquoi Vritti",
        "galleryTitle": "Dans l’app",
        "closingTitle": "Commencez votre prochaine pratique avec Vritti.",
        "languageLabel": "Langue",
        "themeLabel": "Thème",
        "themeSystem": "Auto",
        "themeLight": "Clair",
        "themeDark": "Sombre",
        "instituteName": "l'Institut des Méthodes Orientales de Réhabilitation",
        "footerNoteBefore": "Développée avec le soutien méthodologique de ",
        "footerNoteAfter": ".",
        "appStoreBadgeAlt": "Télécharger dans l’App Store",
        "googlePlayBadgeAlt": "Disponible sur Google Play"
      },
      "freediving": {
        "metaTitle": "Vritti pour l’apnée | App de pratique d’apnée à sec",
        "metaDescription": "Utilisez Vritti pour la pratique d’apnée à sec sur terre. Créez des séances personnalisées d’apnée et de respiration avec minutage flexible, signaux, rappels, widgets et routines enregistrées.",
        "navLabel": "Page apnée",
        "navWhy": "Pourquoi c’est utile",
        "navScreenshots": "Captures",
        "navPrivacy": "Confidentialité",
        "mainPageCta": "Voir la page principale de Vritti",
        "heroKicker": "App pour la pratique d’apnée à sec",
        "heroTitle": "Une pratique d’apnée à sec structurée et simple",
        "heroText": "Créez des séances personnalisées d’apnée et de respiration avec minutage flexible, signaux, rappels, widgets et routines enregistrées.",
        "heroNote": "Idéal pour la pratique à sec sur terre.",
        "whyKicker": "Structure pour la pratique à sec",
        "whyTitle": "Pourquoi les apnéistes peuvent la trouver utile",
        "whyText": "Vritti est une app flexible d’apnée et un minuteur d’apnée pour l’entraînement à la retenue du souffle sur terre, avec des outils pour créer des séances à sec répétables.",
        "benefits": [
          "Créez des séances personnalisées en plusieurs phases",
          "Ajustez le minutage selon votre structure de pratique à sec",
          "Utilisez des signaux sonores, haptiques et visuels",
          "Enregistrez des routines et répétez-les avec régularité",
          "Lancez la pratique plus vite avec widgets et rappels"
        ],
        "featuresKicker": "Fonctions",
        "featuresTitle": "Minutage flexible et routines répétables",
        "screenshotCaptions": [
          "Créez votre propre séance d’apnée",
          "Pratique d’apnée à sec sur terre",
          "Minutage et signaux flexibles",
          "Widgets et rappels pour la régularité",
          "Enregistrez des routines à répéter",
          "Interface simple. Contrôle précis."
        ],
        "designedTitle": "Ce pour quoi Vritti est conçu",
        "designedText": "Vritti est une app flexible de pratique respiratoire qui peut être utile pour structurer l’apnée à sec et le travail respiratoire sur terre.",
        "notTitle": "Ce que ce n’est pas",
        "notText": "Ce n’est pas un remplacement du coaching, de la supervision dans l’eau, des procédures avec binôme ou de la formation à la sécurité en apnée.",
        "useKicker": "Usage pratique",
        "useTitle": "Utilisations possibles",
        "useCases": [
          "Minutage d’apnée à sec",
          "Respiration apaisante avant la pratique",
          "Structure simple de séance d’apnée",
          "Routines respiratoires personnelles entre les entraînements"
        ],
        "trustKicker": "Confiance",
        "trustTitle": "Simple et respectueux de la vie privée",
        "trustPoints": [
          "Disponible sur iPhone et Android",
          "Prend en charge de nombreuses langues d’interface",
          "Aucune donnée collectée, selon la fiche App Store"
        ],
        "privacyLink": "Lire la politique de confidentialité",
        "finalKicker": "Essai gratuit",
        "finalTitle": "Essayez Vritti pour la pratique à sec",
        "finalText": "Si vous voulez une façon simple de structurer des séances de retenue du souffle et de respiration sur terre, Vritti est gratuit à essayer.",
        "safetyNote": "Utilisez Vritti uniquement pour la pratique à sec sur terre. Ce n’est pas un coach d’apnée, un système de sécurité, une app d’entraînement dans l’eau ni un substitut à l’instruction et aux procédures avec binôme."
      },
      "support": {
        "metaTitle": "Support Vritti | Feedback & Ratings",
        "metaDescription": "Share feedback, rate Vritti, and support the free breathing practice app.",
        "title": "Support Vritti",
        "intro": "Vritti is completely free. If it helps your practice, the best ways to support it are a quick rating, honest feedback — or simply telling a friend.",
        "feedbackTitle": "Send feedback",
        "feedbackIntro": "Found a bug, missing a feature, or just want to say hi? We read every message.",
        "messageLabel": "Your message",
        "messagePlaceholder": "What's on your mind?",
        "emailLabel": "Reply email (optional)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Please enter a valid email address or leave the field empty.",
        "messageRequired": "Please write a message first.",
        "send": "Send feedback",
        "sending": "Sending…",
        "success": "Thank you! Your feedback has been sent.",
        "error": "Could not send feedback right now. Please try again in a few minutes.",
        "rateTitle": "Rate the app",
        "rateIntro": "Ratings help other people find Vritti. It takes less than a minute.",
        "rateAppStore": "Rate on the App Store",
        "rateGooglePlay": "Rate on Google Play",
        "donateTitle": "Leave a donation",
        "donateIntro": "If you'd like to support Vritti's development with a small gift, you can do so below. Everything stays optional — the app is and will remain free.",
        "donateButton": "Support on Ko-fi",
        "backHome": "Back to the main page"
      },
      "content": {
        "promoText": "Créez vos propres routines de respiration, combinez plusieurs étapes en une seule séance fluide, ajustez les sons et les repères, et partagez vos pratiques avec d’autres.",
        "summary": "Vritti fait de la respiration un rituel quotidien simple pour retrouver calme, concentration et équilibre.",
        "details": "Créez votre propre flux en combinant exercices de respiration, blocs de méditation et sessions rythmiques dans une seule pratique fluide. Commencez avec des sessions recommandées, ajustez le rythme et les réglages, choisissez les sons qui vous conviennent et partagez vos pratiques avec d'autres. Enregistrez vos étapes personnalisées comme modèles pour créer plus vite de nouvelles pratiques.",
        "features": [
          "Créez et lancez vos propres séquences de pratique",
          "Adaptez chaque pratique grâce à des réglages souples",
          "Enregistrez vos étapes personnalisées comme modèles pour créer plus vite de nouvelles pratiques",
          "Commencez rapidement avec des sessions prêtes à l'emploi et recommandées",
          "Profitez d'une expérience plus immersive avec des sons, repères visuels et retours haptiques",
          "Partagez vos pratiques avec des amis, élèves ou clients",
          "Pratiquez dans une interface claire et intuitive"
        ],
        "closing": "Pour les débutants comme pour les pratiquants expérimentés.\nDéveloppée avec le soutien méthodologique de l'Institut des Méthodes Orientales de Réhabilitation."
      }
    }
  },
  "de": {
    "translation": {
      "meta": {
        "appName": "Vritti",
        "badge": "Atemübungen & Pranayama",
        "dir": "ltr"
      },
      "landing": {
        "heroTitle": "Ein ruhigerer Weg, deine Atempraxis zu gestalten.",
        "featuresTitle": "Warum Vritti",
        "galleryTitle": "In der App",
        "closingTitle": "Starte deine nächste Praxis mit Vritti.",
        "languageLabel": "Sprache",
        "themeLabel": "Thema",
        "themeSystem": "Auto",
        "themeLight": "Hell",
        "themeDark": "Dunkel",
        "instituteName": "Instituts für Östliche Rehabilitationsmethoden",
        "footerNoteBefore": "Entwickelt mit methodischer Unterstützung des ",
        "footerNoteAfter": ".",
        "appStoreBadgeAlt": "Laden im App Store",
        "googlePlayBadgeAlt": "Jetzt bei Google Play"
      },
      "freediving": {
        "metaTitle": "Vritti für Freediving | App für trockenes Apnoe-Training",
        "metaDescription": "Nutze Vritti für trockenes Apnoe-Training an Land. Erstelle eigene Atemhalte- und Atemsitzungen mit flexiblem Timing, Signalen, Erinnerungen, Widgets und gespeicherten Routinen.",
        "navLabel": "Freediving-Seite",
        "navWhy": "Warum es hilft",
        "navScreenshots": "Screenshots",
        "navPrivacy": "Datenschutz",
        "mainPageCta": "Zur Hauptseite von Vritti",
        "heroKicker": "Freediving-App für trockenes Apnoe-Training",
        "heroTitle": "Strukturiertes trockenes Apnoe-Training, einfach gemacht",
        "heroText": "Erstelle eigene Atemhalte- und Atemsitzungen mit flexiblem Timing, Signalen, Erinnerungen, Widgets und gespeicherten Routinen.",
        "heroNote": "Am besten geeignet für trockenes Üben an Land.",
        "whyKicker": "Struktur für trockenes Training",
        "whyTitle": "Warum Freediver es nützlich finden können",
        "whyText": "Vritti ist eine flexible Apnoe-App und ein Atemhalte-Timer für Atemhalte-Training an Land, mit Werkzeugen für wiederholbare trockene Übungseinheiten.",
        "benefits": [
          "Erstelle eigene Sitzungen mit mehreren Phasen",
          "Passe das Timing an deine trockene Übungsstruktur an",
          "Nutze Klang-, Haptik- und visuelle Signale",
          "Speichere Routinen und wiederhole sie konsequent",
          "Starte schneller mit Widgets und Erinnerungen"
        ],
        "featuresKicker": "Funktionen",
        "featuresTitle": "Flexibles Timing und wiederholbare Routinen",
        "screenshotCaptions": [
          "Baue deine eigene Apnoe-Sitzung",
          "Trockenes Atemhalte-Training an Land",
          "Flexibles Timing und Signale",
          "Widgets und Erinnerungen für Kontinuität",
          "Speichere Routinen für wiederholtes Üben",
          "Einfache Oberfläche. Präzise Kontrolle."
        ],
        "designedTitle": "Wofür Vritti entwickelt wurde",
        "designedText": "Vritti ist eine flexible App für Atempraxis, die für die Struktur trockener Atemhalteübungen und Atemarbeit an Land nützlich sein kann.",
        "notTitle": "Was es nicht ist",
        "notText": "Es ersetzt kein Coaching, keine Aufsicht im Wasser, keine Buddy-Verfahren und kein Sicherheitstraining im Freediving.",
        "useKicker": "Praktische Nutzung",
        "useTitle": "Mögliche Anwendungen",
        "useCases": [
          "Timing für trockenes Atemhalten",
          "Beruhigende Atemarbeit vor der Praxis",
          "Einfache Struktur für Apnoe-Sitzungen",
          "Persönliche Atemroutinen zwischen Trainingseinheiten"
        ],
        "trustKicker": "Vertrauen",
        "trustTitle": "Einfach und datenschutzfreundlich",
        "trustPoints": [
          "Verfügbar auf iPhone und Android",
          "Unterstützt viele Oberflächensprachen",
          "Laut App-Store-Eintrag werden keine Daten erfasst"
        ],
        "privacyLink": "Datenschutzerklärung lesen",
        "finalKicker": "Kostenlos ausprobieren",
        "finalTitle": "Probiere Vritti für trockenes Üben",
        "finalText": "Wenn du Atemhalte- und Atemsitzungen an Land einfach strukturieren möchtest, kannst du Vritti kostenlos ausprobieren.",
        "safetyNote": "Nutze Vritti nur für trockenes Üben an Land. Es ist kein Freediving-Coach, kein Sicherheitssystem, keine App für Training im Wasser und kein Ersatz für Anleitung und Buddy-Verfahren."
      },
      "support": {
        "metaTitle": "Support Vritti | Feedback & Ratings",
        "metaDescription": "Share feedback, rate Vritti, and support the free breathing practice app.",
        "title": "Support Vritti",
        "intro": "Vritti is completely free. If it helps your practice, the best ways to support it are a quick rating, honest feedback — or simply telling a friend.",
        "feedbackTitle": "Send feedback",
        "feedbackIntro": "Found a bug, missing a feature, or just want to say hi? We read every message.",
        "messageLabel": "Your message",
        "messagePlaceholder": "What's on your mind?",
        "emailLabel": "Reply email (optional)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Please enter a valid email address or leave the field empty.",
        "messageRequired": "Please write a message first.",
        "send": "Send feedback",
        "sending": "Sending…",
        "success": "Thank you! Your feedback has been sent.",
        "error": "Could not send feedback right now. Please try again in a few minutes.",
        "rateTitle": "Rate the app",
        "rateIntro": "Ratings help other people find Vritti. It takes less than a minute.",
        "rateAppStore": "Rate on the App Store",
        "rateGooglePlay": "Rate on Google Play",
        "donateTitle": "Leave a donation",
        "donateIntro": "If you'd like to support Vritti's development with a small gift, you can do so below. Everything stays optional — the app is and will remain free.",
        "donateButton": "Support on Ko-fi",
        "backHome": "Back to the main page"
      },
      "content": {
        "promoText": "Erstelle eigene Atemflows, kombiniere mehrere Phasen in einer fließenden Session, passe Klänge und Signale an und teile Routinen mit anderen.",
        "summary": "Vritti macht aus Atemübungen ein einfaches tägliches Ritual für Ruhe, Fokus und Regeneration.",
        "details": "Stelle deinen eigenen Ablauf zusammen, indem du Atemübungen, Meditationsblöcke und rhythmische Sessions zu einer fließenden Praxis verbindest. Starte mit empfohlenen Sessions, passe Dauer und Einstellungen an, wähle passende Klänge und teile deine Praxis mit anderen. Speichere eigene Stufen als Vorlagen, um neue Praktiken schneller zu erstellen.",
        "features": [
          "Erstelle und spiele eigene Praxis-Sequenzen ab",
          "Passe jede Praxis flexibel an deinen Rhythmus an",
          "Speichere eigene Stufen als Vorlagen, um neue Praktiken schneller zu erstellen",
          "Starte schnell mit fertigen und empfohlenen Sessions",
          "Erlebe mehr Tiefe mit Klängen, visuellen Hinweisen und haptischem Feedback",
          "Teile deine Praxis mit Freunden, Schülern oder Klienten",
          "Übe in einer klaren, intuitiven Oberfläche"
        ],
        "closing": "Für Einsteiger und erfahrene Praktizierende.\nEntwickelt mit methodischer Unterstützung des Instituts für Östliche Rehabilitationsmethoden."
      }
    }
  },
  "it": {
    "translation": {
      "meta": {
        "appName": "Vritti",
        "badge": "Respirazione e pranayama",
        "dir": "ltr"
      },
      "landing": {
        "heroTitle": "Un modo più sereno di creare la tua pratica di respirazione.",
        "featuresTitle": "Perché Vritti",
        "galleryTitle": "Dentro l’app",
        "closingTitle": "Inizia la tua prossima pratica con Vritti.",
        "languageLabel": "Lingua",
        "themeLabel": "Tema",
        "themeSystem": "Auto",
        "themeLight": "Chiaro",
        "themeDark": "Scuro",
        "instituteName": "Istituto dei Metodi Orientali di Riabilitazione",
        "footerNoteBefore": "Sviluppata con il supporto metodologico dell'",
        "footerNoteAfter": ".",
        "appStoreBadgeAlt": "Scarica su App Store",
        "googlePlayBadgeAlt": "Disponibile su Google Play"
      },
      "freediving": {
        "metaTitle": "Vritti per freediving | App per apnea a secco",
        "metaDescription": "Usa Vritti per la pratica di apnea a secco a terra. Crea sessioni personalizzate di apnea e respirazione con tempi flessibili, segnali, promemoria, widget e routine salvate.",
        "navLabel": "Pagina freediving",
        "navWhy": "Perché aiuta",
        "navScreenshots": "Screenshot",
        "navPrivacy": "Privacy",
        "mainPageCta": "Vai alla pagina principale di Vritti",
        "heroKicker": "App di freediving per apnea a secco",
        "heroTitle": "Pratica di apnea a secco strutturata e semplice",
        "heroText": "Crea sessioni personalizzate di apnea e respirazione con tempi flessibili, segnali, promemoria, widget e routine salvate.",
        "heroNote": "Più adatta alla pratica a secco a terra.",
        "whyKicker": "Struttura per pratica a secco",
        "whyTitle": "Perché può essere utile ai freediver",
        "whyText": "Vritti è un’app flessibile per apnea e un timer per apnea per l’allenamento del trattenimento del respiro a terra, con strumenti per creare pratiche a secco ripetibili.",
        "benefits": [
          "Crea sessioni personalizzate in più fasi",
          "Regola i tempi in base alla tua struttura di pratica a secco",
          "Usa segnali sonori, aptici e visivi",
          "Salva routine e ripetile con costanza",
          "Avvia la pratica più velocemente con widget e promemoria"
        ],
        "featuresKicker": "Funzioni",
        "featuresTitle": "Tempi flessibili e routine ripetibili",
        "screenshotCaptions": [
          "Crea la tua sessione di apnea",
          "Pratica di apnea a secco a terra",
          "Tempi e segnali flessibili",
          "Widget e promemoria per la costanza",
          "Salva routine da ripetere",
          "Interfaccia semplice. Controllo preciso."
        ],
        "designedTitle": "Per cosa è progettato Vritti",
        "designedText": "Vritti è un’app flessibile per la pratica respiratoria che può essere utile per strutturare apnea a secco e lavoro respiratorio a terra.",
        "notTitle": "Cosa non è",
        "notText": "Non sostituisce coaching, supervisione in acqua, procedure con compagno o formazione sulla sicurezza nel freediving.",
        "useKicker": "Uso pratico",
        "useTitle": "Possibili usi",
        "useCases": [
          "Tempi per apnea a secco",
          "Respirazione calmante prima della pratica",
          "Struttura semplice per sessioni di apnea",
          "Routine respiratorie personali tra gli allenamenti"
        ],
        "trustKicker": "Fiducia",
        "trustTitle": "Semplice e rispettosa della privacy",
        "trustPoints": [
          "Disponibile su iPhone e Android",
          "Supporta molte lingue dell’interfaccia",
          "Nessun dato raccolto, secondo la scheda App Store"
        ],
        "privacyLink": "Leggi l’informativa sulla privacy",
        "finalKicker": "Gratis da provare",
        "finalTitle": "Prova Vritti per la pratica a secco",
        "finalText": "Se vuoi un modo semplice per strutturare sessioni di apnea e respirazione a terra, Vritti è gratis da provare.",
        "safetyNote": "Usa Vritti solo per pratica a secco a terra. Non è un coach di freediving, un sistema di sicurezza, un’app per allenamento in acqua né un sostituto di istruzione e procedure con compagno."
      },
      "support": {
        "metaTitle": "Support Vritti | Feedback & Ratings",
        "metaDescription": "Share feedback, rate Vritti, and support the free breathing practice app.",
        "title": "Support Vritti",
        "intro": "Vritti is completely free. If it helps your practice, the best ways to support it are a quick rating, honest feedback — or simply telling a friend.",
        "feedbackTitle": "Send feedback",
        "feedbackIntro": "Found a bug, missing a feature, or just want to say hi? We read every message.",
        "messageLabel": "Your message",
        "messagePlaceholder": "What's on your mind?",
        "emailLabel": "Reply email (optional)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Please enter a valid email address or leave the field empty.",
        "messageRequired": "Please write a message first.",
        "send": "Send feedback",
        "sending": "Sending…",
        "success": "Thank you! Your feedback has been sent.",
        "error": "Could not send feedback right now. Please try again in a few minutes.",
        "rateTitle": "Rate the app",
        "rateIntro": "Ratings help other people find Vritti. It takes less than a minute.",
        "rateAppStore": "Rate on the App Store",
        "rateGooglePlay": "Rate on Google Play",
        "donateTitle": "Leave a donation",
        "donateIntro": "If you'd like to support Vritti's development with a small gift, you can do so below. Everything stays optional — the app is and will remain free.",
        "donateButton": "Support on Ko-fi",
        "backHome": "Back to the main page"
      },
      "content": {
        "promoText": "Crea i tuoi flussi di respirazione, combina più fasi in un’unica sessione fluida, regola suoni e segnali e condividi le routine con altri.",
        "summary": "Vritti trasforma la pratica del respiro in un rituale quotidiano semplice per ritrovare calma, concentrazione ed equilibrio.",
        "details": "Crea il tuo flusso unendo esercizi di respirazione, blocchi di meditazione e sessioni ritmiche in una pratica fluida. Parti dalle sessioni consigliate, regola tempi e impostazioni in base a te, scegli i suoni giusti per il momento e condividi le tue pratiche con gli altri. Salva fasi personalizzate come modelli per creare nuove pratiche più rapidamente.",
        "features": [
          "Crea e avvia sequenze personalizzate di pratica",
          "Modella ogni pratica con impostazioni flessibili",
          "Salva fasi personalizzate come modelli per creare nuove pratiche più rapidamente",
          "Inizia subito con sessioni pronte e consigliate",
          "Vivi un'esperienza più immersiva con suoni, segnali visivi e feedback aptico",
          "Condividi le tue pratiche con amici, allievi o clienti",
          "Pratica in un'interfaccia pulita e intuitiva"
        ],
        "closing": "Per chi inizia e per chi ha già esperienza.\nSviluppata con il supporto metodologico dell'Istituto dei Metodi Orientali di Riabilitazione."
      }
    }
  },
  "pt-BR": {
    "translation": {
      "meta": {
        "appName": "Vritti",
        "badge": "Respiração e pranayama",
        "dir": "ltr"
      },
      "landing": {
        "heroTitle": "Uma forma mais tranquila de criar sua prática respiratória.",
        "featuresTitle": "Por que Vritti",
        "galleryTitle": "Dentro do app",
        "closingTitle": "Comece sua próxima prática com Vritti.",
        "languageLabel": "Idioma",
        "themeLabel": "Tema",
        "themeSystem": "Auto",
        "themeLight": "Claro",
        "themeDark": "Escuro",
        "instituteName": "Instituto de Métodos Orientais de Reabilitação",
        "footerNoteBefore": "Desenvolvido com apoio metodológico do ",
        "footerNoteAfter": ".",
        "appStoreBadgeAlt": "Baixar na App Store",
        "googlePlayBadgeAlt": "Disponível no Google Play"
      },
      "freediving": {
        "metaTitle": "Vritti para mergulho livre | App de apneia seca",
        "metaDescription": "Use o Vritti para prática de apneia seca em terra. Crie sessões personalizadas de apneia e respiração com tempos flexíveis, sinais, lembretes, widgets e rotinas salvas.",
        "navLabel": "Página de mergulho livre",
        "navWhy": "Por que ajuda",
        "navScreenshots": "Capturas",
        "navPrivacy": "Privacidade",
        "mainPageCta": "Ver a página principal do Vritti",
        "heroKicker": "App de mergulho livre para apneia seca",
        "heroTitle": "Prática de apneia seca estruturada e simples",
        "heroText": "Crie sessões personalizadas de apneia e respiração com tempos flexíveis, sinais, lembretes, widgets e rotinas salvas.",
        "heroNote": "Mais indicado para prática seca em terra.",
        "whyKicker": "Estrutura para prática seca",
        "whyTitle": "Por que mergulhadores livres podem achar útil",
        "whyText": "O Vritti é um app flexível de apneia e temporizador de apneia para treino de retenção da respiração em terra, com ferramentas para criar sessões secas repetíveis.",
        "benefits": [
          "Crie sessões personalizadas com várias etapas",
          "Ajuste os tempos para sua própria estrutura de prática seca",
          "Use sinais sonoros, hápticos e visuais",
          "Salve rotinas e repita-as com consistência",
          "Inicie a prática mais rápido com widgets e lembretes"
        ],
        "featuresKicker": "Recursos",
        "featuresTitle": "Tempos flexíveis e rotinas repetíveis",
        "screenshotCaptions": [
          "Crie sua própria sessão de apneia",
          "Prática de apneia seca em terra",
          "Tempos e sinais flexíveis",
          "Widgets e lembretes para consistência",
          "Salve rotinas para repetir",
          "Interface simples. Controle preciso."
        ],
        "designedTitle": "Para que o Vritti foi criado",
        "designedText": "O Vritti é um app flexível de prática respiratória que pode ser útil para estruturar apneia seca e trabalho respiratório em terra.",
        "notTitle": "O que ele não é",
        "notText": "Ele não substitui coaching, supervisão na água, procedimentos com dupla ou treinamento de segurança em mergulho livre.",
        "useKicker": "Uso prático",
        "useTitle": "Possíveis usos",
        "useCases": [
          "Temporização de apneia seca",
          "Respiração calmante antes da prática",
          "Estrutura simples de sessão de apneia",
          "Rotinas pessoais de respiração entre treinos"
        ],
        "trustKicker": "Confiança",
        "trustTitle": "Simples e amigável à privacidade",
        "trustPoints": [
          "Disponível para iPhone e Android",
          "Compatível com muitos idiomas de interface",
          "Nenhum dado coletado, segundo a página da App Store"
        ],
        "privacyLink": "Ler a política de privacidade",
        "finalKicker": "Grátis para testar",
        "finalTitle": "Experimente o Vritti para prática seca",
        "finalText": "Se você quer uma forma simples de estruturar sessões de apneia e respiração em terra, o Vritti é grátis para testar.",
        "safetyNote": "Use o Vritti apenas para prática seca em terra. Ele não é um treinador de mergulho livre, sistema de segurança, app de treino na água nem substituto para instrução e procedimentos com dupla."
      },
      "support": {
        "metaTitle": "Support Vritti | Feedback & Ratings",
        "metaDescription": "Share feedback, rate Vritti, and support the free breathing practice app.",
        "title": "Support Vritti",
        "intro": "Vritti is completely free. If it helps your practice, the best ways to support it are a quick rating, honest feedback — or simply telling a friend.",
        "feedbackTitle": "Send feedback",
        "feedbackIntro": "Found a bug, missing a feature, or just want to say hi? We read every message.",
        "messageLabel": "Your message",
        "messagePlaceholder": "What's on your mind?",
        "emailLabel": "Reply email (optional)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Please enter a valid email address or leave the field empty.",
        "messageRequired": "Please write a message first.",
        "send": "Send feedback",
        "sending": "Sending…",
        "success": "Thank you! Your feedback has been sent.",
        "error": "Could not send feedback right now. Please try again in a few minutes.",
        "rateTitle": "Rate the app",
        "rateIntro": "Ratings help other people find Vritti. It takes less than a minute.",
        "rateAppStore": "Rate on the App Store",
        "rateGooglePlay": "Rate on Google Play",
        "donateTitle": "Leave a donation",
        "donateIntro": "If you'd like to support Vritti's development with a small gift, you can do so below. Everything stays optional — the app is and will remain free.",
        "donateButton": "Support on Ko-fi",
        "backHome": "Back to the main page"
      },
      "content": {
        "promoText": "Crie seus próprios fluxos de respiração, combine várias etapas em uma sessão fluida, ajuste sons e sinais e compartilhe rotinas com outras pessoas.",
        "summary": "Vritti transforma a prática respiratória em um ritual diário simples para trazer calma, foco e equilíbrio.",
        "details": "Monte seu próprio fluxo combinando exercícios de respiração, blocos de meditação e sessões rítmicas em uma prática fluida. Comece com sessões recomendadas, ajuste tempo e configurações do seu jeito, escolha os sons que combinam com você e compartilhe suas práticas com outras pessoas. Salve etapas personalizadas como modelos para criar novas práticas mais rápido.",
        "features": [
          "Crie e reproduza sequências personalizadas de prática",
          "Ajuste cada prática com configurações flexíveis",
          "Salve etapas personalizadas como modelos para criar novas práticas mais rápido",
          "Comece rápido com sessões prontas e recomendadas",
          "Tenha uma experiência mais imersiva com sons, sinais visuais e feedback tátil",
          "Compartilhe suas práticas com amigos, alunos ou clientes",
          "Pratique em uma interface limpa e intuitiva"
        ],
        "closing": "Feito para iniciantes e praticantes experientes.\nDesenvolvido com apoio metodológico do Instituto de Métodos Orientais de Reabilitação."
      }
    }
  },
  "pl": {
    "translation": {
      "meta": {
        "appName": "Vritti",
        "badge": "Oddech i pranajama",
        "dir": "ltr"
      },
      "landing": {
        "heroTitle": "Spokojniejszy sposób na ułożenie własnej praktyki oddechowej.",
        "featuresTitle": "Dlaczego Vritti",
        "galleryTitle": "W aplikacji",
        "closingTitle": "Rozpocznij kolejną praktykę z Vritti.",
        "languageLabel": "Język",
        "themeLabel": "Motyw",
        "themeSystem": "Auto",
        "themeLight": "Jasny",
        "themeDark": "Ciemny",
        "instituteName": "Instytutu Wschodnich Metod Rehabilitacji",
        "footerNoteBefore": "Stworzona przy wsparciu metodologicznym ",
        "footerNoteAfter": ".",
        "appStoreBadgeAlt": "Pobierz z App Store",
        "googlePlayBadgeAlt": "Pobierz z Google Play"
      },
      "freediving": {
        "metaTitle": "Vritti dla freedivingu | Aplikacja do suchej praktyki bezdechu",
        "metaDescription": "Używaj Vritti do suchej praktyki bezdechu na lądzie. Twórz własne sesje wstrzymywania oddechu i oddychania z elastycznym czasem, sygnałami, przypomnieniami, widżetami i zapisanymi rutynami.",
        "navLabel": "Strona freedivingu",
        "navWhy": "Dlaczego pomaga",
        "navScreenshots": "Zrzuty ekranu",
        "navPrivacy": "Prywatność",
        "mainPageCta": "Zobacz główną stronę Vritti",
        "heroKicker": "Aplikacja freedivingowa do suchej praktyki bezdechu",
        "heroTitle": "Strukturalna sucha praktyka bezdechu, prosta w użyciu",
        "heroText": "Twórz własne sesje wstrzymywania oddechu i oddychania z elastycznym czasem, sygnałami, przypomnieniami, widżetami i zapisanymi rutynami.",
        "heroNote": "Najlepiej nadaje się do suchej praktyki na lądzie.",
        "whyKicker": "Struktura suchej praktyki",
        "whyTitle": "Dlaczego freediverzy mogą uznać to za przydatne",
        "whyText": "Vritti to elastyczna aplikacja do bezdechu i timer wstrzymywania oddechu do treningu na lądzie, z narzędziami do tworzenia powtarzalnych suchych sesji.",
        "benefits": [
          "Twórz własne sesje wieloetapowe",
          "Dostosuj czas do swojej struktury suchej praktyki",
          "Używaj sygnałów dźwiękowych, haptycznych i wizualnych",
          "Zapisuj rutyny i powtarzaj je regularnie",
          "Uruchamiaj praktykę szybciej dzięki widżetom i przypomnieniom"
        ],
        "featuresKicker": "Funkcje",
        "featuresTitle": "Elastyczny czas i powtarzalne rutyny",
        "screenshotCaptions": [
          "Zbuduj własną sesję bezdechu",
          "Sucha praktyka wstrzymywania oddechu na lądzie",
          "Elastyczny czas i sygnały",
          "Widżety i przypomnienia dla regularności",
          "Zapisuj rutyny do powtórzeń",
          "Prosty interfejs. Precyzyjna kontrola."
        ],
        "designedTitle": "Do czego zaprojektowano Vritti",
        "designedText": "Vritti to elastyczna aplikacja do praktyki oddechowej, która może pomóc w strukturze suchego wstrzymywania oddechu i pracy z oddechem na lądzie.",
        "notTitle": "Czym nie jest",
        "notText": "Nie zastępuje coachingu, nadzoru w wodzie, procedur z partnerem ani szkolenia bezpieczeństwa we freedivingu.",
        "useKicker": "Praktyczne użycie",
        "useTitle": "Możliwe zastosowania",
        "useCases": [
          "Czas suchego wstrzymywania oddechu",
          "Uspokajająca praca z oddechem przed praktyką",
          "Prosta struktura sesji bezdechu",
          "Osobiste rutyny oddechowe między treningami"
        ],
        "trustKicker": "Zaufanie",
        "trustTitle": "Prosta i przyjazna prywatności",
        "trustPoints": [
          "Dostępna na iPhone i Androida",
          "Obsługuje wiele języków interfejsu",
          "Według App Store nie zbiera danych"
        ],
        "privacyLink": "Przeczytaj politykę prywatności",
        "finalKicker": "Do wypróbowania za darmo",
        "finalTitle": "Wypróbuj Vritti do suchej praktyki",
        "finalText": "Jeśli chcesz prostego sposobu na strukturę sesji bezdechu i oddychania na lądzie, Vritti możesz wypróbować za darmo.",
        "safetyNote": "Używaj Vritti tylko do suchej praktyki na lądzie. To nie jest trener freedivingu, system bezpieczeństwa, aplikacja do treningu w wodzie ani zamiennik instruktażu i procedur z partnerem."
      },
      "support": {
        "metaTitle": "Support Vritti | Feedback & Ratings",
        "metaDescription": "Share feedback, rate Vritti, and support the free breathing practice app.",
        "title": "Support Vritti",
        "intro": "Vritti is completely free. If it helps your practice, the best ways to support it are a quick rating, honest feedback — or simply telling a friend.",
        "feedbackTitle": "Send feedback",
        "feedbackIntro": "Found a bug, missing a feature, or just want to say hi? We read every message.",
        "messageLabel": "Your message",
        "messagePlaceholder": "What's on your mind?",
        "emailLabel": "Reply email (optional)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Please enter a valid email address or leave the field empty.",
        "messageRequired": "Please write a message first.",
        "send": "Send feedback",
        "sending": "Sending…",
        "success": "Thank you! Your feedback has been sent.",
        "error": "Could not send feedback right now. Please try again in a few minutes.",
        "rateTitle": "Rate the app",
        "rateIntro": "Ratings help other people find Vritti. It takes less than a minute.",
        "rateAppStore": "Rate on the App Store",
        "rateGooglePlay": "Rate on Google Play",
        "donateTitle": "Leave a donation",
        "donateIntro": "If you'd like to support Vritti's development with a small gift, you can do so below. Everything stays optional — the app is and will remain free.",
        "donateButton": "Support on Ko-fi",
        "backHome": "Back to the main page"
      },
      "content": {
        "promoText": "Twórz własne sekwencje oddechowe, łącz wiele etapów w jedną płynną sesję, dostosowuj dźwięki i sygnały oraz udostępniaj praktyki innym.",
        "summary": "Vritti zamienia praktykę oddechu w prosty codzienny rytuał, który pomaga odzyskać spokój, skupienie i równowagę.",
        "details": "Twórz własny rytm praktyki, łącząc ćwiczenia oddechowe, bloki medytacji i rytmiczne sesje w jedną płynną całość. Zacznij od polecanych sesji, dopasuj czas i ustawienia do siebie, wybierz dźwięki, które Ci odpowiadają, i dziel się swoimi praktykami z innymi. Zapisuj własne etapy jako szablony, aby szybciej tworzyć nowe praktyki.",
        "features": [
          "Twórz i odtwarzaj własne sekwencje praktyk",
          "Elastycznie dopasowuj każdą praktykę do siebie",
          "Zapisuj własne etapy jako szablony, aby szybciej tworzyć nowe praktyki",
          "Zaczynaj szybko z gotowymi i polecanymi sesjami",
          "Korzystaj z dźwięków, wskazówek wizualnych i haptyki dla głębszego doświadczenia",
          "Udostępniaj praktyki znajomym, uczniom lub klientom",
          "Ćwicz w czystym i intuicyjnym interfejsie"
        ],
        "closing": "Dla początkujących i zaawansowanych.\nStworzona przy wsparciu metodologicznym Instytutu Wschodnich Metod Rehabilitacji."
      }
    }
  },
  "nl": {
    "translation": {
      "meta": {
        "appName": "Vritti",
        "badge": "Ademhaling & pranayama",
        "dir": "ltr"
      },
      "landing": {
        "heroTitle": "Een rustigere manier om je ademhalingsoefening vorm te geven.",
        "featuresTitle": "Waarom Vritti",
        "galleryTitle": "In de app",
        "closingTitle": "Begin je volgende sessie met Vritti.",
        "languageLabel": "Taal",
        "themeLabel": "Thema",
        "themeSystem": "Auto",
        "themeLight": "Licht",
        "themeDark": "Donker",
        "instituteName": "Instituut voor Oosterse Revalidatiemethoden",
        "footerNoteBefore": "Ontwikkeld met methodologische ondersteuning van het ",
        "footerNoteAfter": ".",
        "appStoreBadgeAlt": "Download in de App Store",
        "googlePlayBadgeAlt": "Nu op Google Play"
      },
      "freediving": {
        "metaTitle": "Vritti voor freediving | App voor droge apnea-oefening",
        "metaDescription": "Gebruik Vritti voor droge apnea-oefening op het land. Bouw aangepaste ademstop- en ademsessies met flexibele timing, signalen, herinneringen, widgets en opgeslagen routines.",
        "navLabel": "Freediving-pagina",
        "navWhy": "Waarom het helpt",
        "navScreenshots": "Screenshots",
        "navPrivacy": "Privacy",
        "mainPageCta": "Bekijk de hoofdsite van Vritti",
        "heroKicker": "Freediving-app voor droge apnea-oefening",
        "heroTitle": "Gestructureerde droge apnea-oefening, eenvoudig gemaakt",
        "heroText": "Bouw aangepaste ademstop- en ademsessies met flexibele timing, signalen, herinneringen, widgets en opgeslagen routines.",
        "heroNote": "Het meest geschikt voor droge oefening op het land.",
        "whyKicker": "Structuur voor droge oefening",
        "whyTitle": "Waarom freedivers dit nuttig kunnen vinden",
        "whyText": "Vritti is een flexibele apnea-app en ademstop-timer voor ademstoptraining op het land, met hulpmiddelen voor herhaalbare droge oefensessies.",
        "benefits": [
          "Maak aangepaste sessies met meerdere fases",
          "Pas timing aan je eigen droge oefenstructuur aan",
          "Gebruik geluid, haptische en visuele signalen",
          "Bewaar routines en herhaal ze consequent",
          "Start sneller met widgets en herinneringen"
        ],
        "featuresKicker": "Functies",
        "featuresTitle": "Flexibele timing en herhaalbare routines",
        "screenshotCaptions": [
          "Bouw je eigen apnea-sessie",
          "Droge ademstopoefening op het land",
          "Flexibele timing en signalen",
          "Widgets en herinneringen voor consistentie",
          "Bewaar routines om te herhalen",
          "Eenvoudige interface. Precieze controle."
        ],
        "designedTitle": "Waar Vritti voor is ontworpen",
        "designedText": "Vritti is een flexibele app voor ademoefening die nuttig kan zijn voor droge ademstopstructuur en ademwerk op het land.",
        "notTitle": "Wat het niet is",
        "notText": "Het is geen vervanging voor coaching, toezicht in het water, buddyprocedures of veiligheidstraining voor freediving.",
        "useKicker": "Praktisch gebruik",
        "useTitle": "Mogelijke toepassingen",
        "useCases": [
          "Timing voor droge ademstop",
          "Kalmerend ademwerk vóór de oefening",
          "Eenvoudige structuur voor apnea-sessies",
          "Persoonlijke ademroutines tussen trainingen"
        ],
        "trustKicker": "Vertrouwen",
        "trustTitle": "Eenvoudig en privacyvriendelijk",
        "trustPoints": [
          "Beschikbaar op iPhone en Android",
          "Ondersteunt veel interfacetalen",
          "Volgens de App Store-pagina worden geen gegevens verzameld"
        ],
        "privacyLink": "Lees het privacybeleid",
        "finalKicker": "Gratis te proberen",
        "finalTitle": "Probeer Vritti voor droge oefening",
        "finalText": "Als je een eenvoudige manier wilt om ademstop- en ademsessies op het land te structureren, kun je Vritti gratis proberen.",
        "safetyNote": "Gebruik Vritti alleen voor droge oefening op het land. Het is geen freedivingcoach, veiligheidssysteem, app voor training in het water of vervanging voor instructie en buddyprocedures."
      },
      "support": {
        "metaTitle": "Support Vritti | Feedback & Ratings",
        "metaDescription": "Share feedback, rate Vritti, and support the free breathing practice app.",
        "title": "Support Vritti",
        "intro": "Vritti is completely free. If it helps your practice, the best ways to support it are a quick rating, honest feedback — or simply telling a friend.",
        "feedbackTitle": "Send feedback",
        "feedbackIntro": "Found a bug, missing a feature, or just want to say hi? We read every message.",
        "messageLabel": "Your message",
        "messagePlaceholder": "What's on your mind?",
        "emailLabel": "Reply email (optional)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Please enter a valid email address or leave the field empty.",
        "messageRequired": "Please write a message first.",
        "send": "Send feedback",
        "sending": "Sending…",
        "success": "Thank you! Your feedback has been sent.",
        "error": "Could not send feedback right now. Please try again in a few minutes.",
        "rateTitle": "Rate the app",
        "rateIntro": "Ratings help other people find Vritti. It takes less than a minute.",
        "rateAppStore": "Rate on the App Store",
        "rateGooglePlay": "Rate on Google Play",
        "donateTitle": "Leave a donation",
        "donateIntro": "If you'd like to support Vritti's development with a small gift, you can do so below. Everything stays optional — the app is and will remain free.",
        "donateButton": "Support on Ko-fi",
        "backHome": "Back to the main page"
      },
      "content": {
        "promoText": "Bouw je eigen ademhalingsflow, combineer meerdere fasen in één vloeiende sessie, pas geluiden en signalen aan en deel routines met anderen.",
        "summary": "Vritti maakt ademhaling tot een eenvoudig dagelijks ritueel voor rust, focus en herstel.",
        "details": "Stel je eigen routine samen door ademhalingsoefeningen, meditatieblokken en ritmische sessies te combineren tot één vloeiend geheel. Begin met aanbevolen sessies, stem tijd en instellingen af op wat jij nodig hebt, kies geluiden die bij je passen en deel je routines met anderen. Bewaar aangepaste fases als sjablonen om sneller nieuwe oefeningen te maken.",
        "features": [
          "Maak en speel je eigen oefenreeksen af",
          "Pas elke sessie flexibel aan jouw ritme aan",
          "Bewaar aangepaste fases als sjablonen om sneller nieuwe oefeningen te maken",
          "Start snel met kant-en-klare en aanbevolen sessies",
          "Ervaar meer diepte met geluiden, visuele aanwijzingen en haptische feedback",
          "Deel je routines met vrienden, leerlingen of cliënten",
          "Oefen in een schone, intuïtieve interface"
        ],
        "closing": "Voor beginners en ervaren beoefenaars.\nOntwikkeld met methodologische ondersteuning van het Instituut voor Oosterse Revalidatiemethoden."
      }
    }
  },
  "ar": {
    "translation": {
      "meta": {
        "appName": "فريتي",
        "badge": "التنفس والبراناياما",
        "dir": "rtl"
      },
      "landing": {
        "heroTitle": "طريقة أكثر هدوءًا لبناء ممارستك التنفسية.",
        "featuresTitle": "لماذا Vritti",
        "galleryTitle": "داخل التطبيق",
        "closingTitle": "ابدأ ممارستك التالية مع Vritti.",
        "languageLabel": "اللغة",
        "themeLabel": "المظهر",
        "themeSystem": "تلقائي",
        "themeLight": "فاتح",
        "themeDark": "داكن",
        "instituteName": "معهد أساليب التأهيل الشرقية",
        "footerNoteBefore": "تم تطويره بدعم منهجي من ",
        "footerNoteAfter": ".",
        "appStoreBadgeAlt": "التنزيل من App Store",
        "googlePlayBadgeAlt": "متوفر على Google Play"
      },
      "freediving": {
        "metaTitle": "Vritti للغوص الحر | تطبيق لممارسة حبس النفس الجافة",
        "metaDescription": "استخدم Vritti لممارسة حبس النفس الجافة على اليابسة. أنشئ جلسات مخصصة لحبس النفس والتنفس مع توقيت مرن، وإشارات، وتذكيرات، وودجات، وروتينات محفوظة.",
        "navLabel": "صفحة الغوص الحر",
        "navWhy": "لماذا يفيد",
        "navScreenshots": "لقطات الشاشة",
        "navPrivacy": "الخصوصية",
        "mainPageCta": "عرض صفحة Vritti الرئيسية",
        "heroKicker": "تطبيق للغوص الحر لممارسة حبس النفس الجافة",
        "heroTitle": "ممارسة حبس نفس جافة منظمة وبسيطة",
        "heroText": "أنشئ جلسات مخصصة لحبس النفس والتنفس مع توقيت مرن، وإشارات، وتذكيرات، وودجات، وروتينات محفوظة.",
        "heroNote": "الأنسب للممارسة الجافة على اليابسة.",
        "whyKicker": "هيكل للممارسة الجافة",
        "whyTitle": "لماذا قد يجده ممارسو الغوص الحر مفيدًا",
        "whyText": "Vritti تطبيق مرن للأبنيا ومؤقت لحبس النفس لتدريب حبس النفس على اليابسة، مع أدوات لبناء جلسات جافة قابلة للتكرار.",
        "benefits": [
          "أنشئ جلسات مخصصة متعددة المراحل",
          "اضبط التوقيت حسب هيكل ممارستك الجافة",
          "استخدم إشارات صوتية ولمسية ومرئية",
          "احفظ الروتينات وكررها بانتظام",
          "ابدأ الممارسة أسرع باستخدام الودجات والتذكيرات"
        ],
        "featuresKicker": "الميزات",
        "featuresTitle": "توقيت مرن وروتينات قابلة للتكرار",
        "screenshotCaptions": [
          "أنشئ جلسة أبنيا خاصة بك",
          "ممارسة حبس النفس الجافة على اليابسة",
          "توقيت وإشارات مرنة",
          "ودجات وتذكيرات للاستمرارية",
          "احفظ الروتينات لتكرار الممارسة",
          "واجهة بسيطة. تحكم دقيق."
        ],
        "designedTitle": "ما صُمم Vritti من أجله",
        "designedText": "Vritti تطبيق مرن لممارسة التنفس يمكن أن يكون مفيدًا لبناء هيكل لحبس النفس الجاف والعمل التنفسي على اليابسة.",
        "notTitle": "ما ليس عليه",
        "notText": "لا يحل محل التدريب مع مدرب، أو الإشراف داخل الماء، أو إجراءات الرفيق، أو تدريب السلامة في الغوص الحر.",
        "useKicker": "استخدام عملي",
        "useTitle": "استخدامات ممكنة",
        "useCases": [
          "توقيت حبس النفس الجاف",
          "تنفس مهدئ قبل الممارسة",
          "هيكل بسيط لجلسة أبنيا",
          "روتينات تنفس شخصية بين جلسات التدريب"
        ],
        "trustKicker": "الثقة",
        "trustTitle": "بسيط وصديق للخصوصية",
        "trustPoints": [
          "متاح على iPhone وAndroid",
          "يدعم العديد من لغات الواجهة",
          "لا يتم جمع البيانات حسب صفحة App Store"
        ],
        "privacyLink": "اقرأ سياسة الخصوصية",
        "finalKicker": "مجاني للتجربة",
        "finalTitle": "جرّب Vritti للممارسة الجافة",
        "finalText": "إذا أردت طريقة بسيطة لتنظيم جلسات حبس النفس والتنفس على اليابسة، يمكنك تجربة Vritti مجانًا.",
        "safetyNote": "استخدم Vritti فقط للممارسة الجافة على اليابسة. إنه ليس مدربًا للغوص الحر، ولا نظام سلامة، ولا تطبيق تدريب داخل الماء، ولا بديلًا عن التعليم وإجراءات الرفيق."
      },
      "support": {
        "metaTitle": "Support Vritti | Feedback & Ratings",
        "metaDescription": "Share feedback, rate Vritti, and support the free breathing practice app.",
        "title": "Support Vritti",
        "intro": "Vritti is completely free. If it helps your practice, the best ways to support it are a quick rating, honest feedback — or simply telling a friend.",
        "feedbackTitle": "Send feedback",
        "feedbackIntro": "Found a bug, missing a feature, or just want to say hi? We read every message.",
        "messageLabel": "Your message",
        "messagePlaceholder": "What's on your mind?",
        "emailLabel": "Reply email (optional)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Please enter a valid email address or leave the field empty.",
        "messageRequired": "Please write a message first.",
        "send": "Send feedback",
        "sending": "Sending…",
        "success": "Thank you! Your feedback has been sent.",
        "error": "Could not send feedback right now. Please try again in a few minutes.",
        "rateTitle": "Rate the app",
        "rateIntro": "Ratings help other people find Vritti. It takes less than a minute.",
        "rateAppStore": "Rate on the App Store",
        "rateGooglePlay": "Rate on Google Play",
        "donateTitle": "Leave a donation",
        "donateIntro": "If you'd like to support Vritti's development with a small gift, you can do so below. Everything stays optional — the app is and will remain free.",
        "donateButton": "Support on Ko-fi",
        "backHome": "Back to the main page"
      },
      "content": {
        "promoText": "أنشئ روتين تنفس مخصصًا، واجمع عدة مراحل في جلسة واحدة سلسة، واضبط الأصوات والإشارات، وشارك الممارسات مع الأصدقاء أو الطلاب أو العملاء.",
        "summary": "يجعل Vritti تمارين التنفس عادة يومية بسيطة تمنحك الهدوء والتركيز واستعادة التوازن.",
        "details": "أنشئ تدفّقك الخاص عبر جمع تمارين التنفس، وفقرات التأمل، والجلسات الإيقاعية في ممارسة واحدة سلسة. ابدأ بالجلسات الموصى بها، واضبط الوقت والإعدادات كما يناسبك، واختر الأصوات التي تلائم مزاجك، وشارك ممارساتك مع الآخرين. احفظ المراحل المخصصة كقوالب لتنشئ ممارسات جديدة بسرعة أكبر.",
        "features": [
          "أنشئ وشغّل تسلسلاتك الخاصة من الممارسات",
          "خصّص كل ممارسة بإعدادات مرنة",
          "احفظ المراحل المخصصة كقوالب لتنشئ ممارسات جديدة بسرعة أكبر",
          "ابدأ بسرعة بجلسات جاهزة وأخرى موصى بها",
          "استمتع بتجربة أكثر غمرًا مع الأصوات والإشارات البصرية واللمسية",
          "شارك ممارساتك مع الأصدقاء أو الطلاب أو العملاء",
          "تدرّب داخل واجهة نظيفة وسهلة"
        ],
        "closing": "مناسب للمبتدئين وللممارسين ذوي الخبرة.\nتم تطويره بدعم منهجي من معهد أساليب التأهيل الشرقية."
      }
    }
  },
  "he": {
    "translation": {
      "meta": {
        "appName": "Vritti",
        "badge": "נשימה ופרניאמה",
        "dir": "rtl"
      },
      "landing": {
        "heroTitle": "דרך רגועה יותר לבנות את תרגול הנשימה שלך.",
        "featuresTitle": "למה Vritti",
        "galleryTitle": "בתוך האפליקציה",
        "closingTitle": "התחילו את התרגול הבא שלכם עם Vritti.",
        "languageLabel": "שפה",
        "themeLabel": "ערכת נושא",
        "themeSystem": "אוטומטי",
        "themeLight": "בהיר",
        "themeDark": "כהה",
        "instituteName": "המכון לשיטות מזרחיות לשיקום",
        "footerNoteBefore": "פותחה בתמיכה מתודולוגית של ",
        "footerNoteAfter": ".",
        "appStoreBadgeAlt": "להורדה ב-App Store",
        "googlePlayBadgeAlt": "זמין ב-Google Play"
      },
      "freediving": {
        "metaTitle": "Vritti לצלילה חופשית | אפליקציה לאימון אפניאה יבש",
        "metaDescription": "השתמשו ב‑Vritti לתרגול אפניאה יבש ביבשה. בנו סשנים מותאמים של עצירת נשימה ונשימה עם תזמון גמיש, סימונים, תזכורות, ווידג׳טים ושגרות שמורות.",
        "navLabel": "עמוד צלילה חופשית",
        "navWhy": "למה זה עוזר",
        "navScreenshots": "צילומי מסך",
        "navPrivacy": "פרטיות",
        "mainPageCta": "לעמוד הראשי של Vritti",
        "heroKicker": "אפליקציה לצלילה חופשית לתרגול אפניאה יבש",
        "heroTitle": "תרגול אפניאה יבש ומובנה, בפשטות",
        "heroText": "בנו סשנים מותאמים של עצירת נשימה ונשימה עם תזמון גמיש, סימונים, תזכורות, ווידג׳טים ושגרות שמורות.",
        "heroNote": "מתאים בעיקר לתרגול יבש ביבשה.",
        "whyKicker": "מבנה לתרגול יבש",
        "whyTitle": "למה צוללים חופשיים עשויים למצוא בזה ערך",
        "whyText": "Vritti היא אפליקציית אפניאה גמישה וטיימר עצירת נשימה לתרגול עצירת נשימה ביבשה, עם כלים לבניית סשנים יבשים שניתן לחזור עליהם.",
        "benefits": [
          "צרו סשנים מותאמים מרובי שלבים",
          "התאימו את התזמון למבנה התרגול היבש שלכם",
          "השתמשו בסימונים קוליים, תחושתיים וחזותיים",
          "שמרו שגרות וחזרו עליהן בעקביות",
          "התחילו תרגול מהר יותר עם ווידג׳טים ותזכורות"
        ],
        "featuresKicker": "יכולות",
        "featuresTitle": "תזמון גמיש ושגרות שניתן לחזור עליהן",
        "screenshotCaptions": [
          "בנו סשן אפניאה משלכם",
          "תרגול עצירת נשימה יבש ביבשה",
          "תזמון וסימונים גמישים",
          "ווידג׳טים ותזכורות לעקביות",
          "שמרו שגרות לתרגול חוזר",
          "ממשק פשוט. שליטה מדויקת."
        ],
        "designedTitle": "למה Vritti מיועדת",
        "designedText": "Vritti היא אפליקציה גמישה לתרגול נשימה שיכולה לעזור במבנה עצירות נשימה יבשות ועבודת נשימה ביבשה.",
        "notTitle": "מה היא לא",
        "notText": "היא אינה תחליף לאימון עם מדריך, להשגחה במים, לנוהלי בן זוג או להכשרת בטיחות בצלילה חופשית.",
        "useKicker": "שימוש מעשי",
        "useTitle": "שימושים אפשריים",
        "useCases": [
          "תזמון עצירת נשימה יבשה",
          "נשימה מרגיעה לפני תרגול",
          "מבנה פשוט לסשן אפניאה",
          "שגרות נשימה אישיות בין אימונים"
        ],
        "trustKicker": "אמון",
        "trustTitle": "פשוטה וידידותית לפרטיות",
        "trustPoints": [
          "זמינה ל‑iPhone ול‑Android",
          "תומכת בשפות ממשק רבות",
          "לפי עמוד ה‑App Store, לא נאספים נתונים"
        ],
        "privacyLink": "קראו את מדיניות הפרטיות",
        "finalKicker": "חינם להתנסות",
        "finalTitle": "נסו את Vritti לתרגול יבש",
        "finalText": "אם אתם רוצים דרך פשוטה לבנות סשנים של עצירת נשימה ונשימה ביבשה, אפשר לנסות את Vritti בחינם.",
        "safetyNote": "השתמשו ב‑Vritti רק לתרגול יבש ביבשה. זו אינה מדריכת צלילה חופשית, מערכת בטיחות, אפליקציה לאימון במים או תחליף להדרכה ולנוהלי בן זוג."
      },
      "support": {
        "metaTitle": "Support Vritti | Feedback & Ratings",
        "metaDescription": "Share feedback, rate Vritti, and support the free breathing practice app.",
        "title": "Support Vritti",
        "intro": "Vritti is completely free. If it helps your practice, the best ways to support it are a quick rating, honest feedback — or simply telling a friend.",
        "feedbackTitle": "Send feedback",
        "feedbackIntro": "Found a bug, missing a feature, or just want to say hi? We read every message.",
        "messageLabel": "Your message",
        "messagePlaceholder": "What's on your mind?",
        "emailLabel": "Reply email (optional)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Please enter a valid email address or leave the field empty.",
        "messageRequired": "Please write a message first.",
        "send": "Send feedback",
        "sending": "Sending…",
        "success": "Thank you! Your feedback has been sent.",
        "error": "Could not send feedback right now. Please try again in a few minutes.",
        "rateTitle": "Rate the app",
        "rateIntro": "Ratings help other people find Vritti. It takes less than a minute.",
        "rateAppStore": "Rate on the App Store",
        "rateGooglePlay": "Rate on Google Play",
        "donateTitle": "Leave a donation",
        "donateIntro": "If you'd like to support Vritti's development with a small gift, you can do so below. Everything stays optional — the app is and will remain free.",
        "donateButton": "Support on Ko-fi",
        "backHome": "Back to the main page"
      },
      "content": {
        "promoText": "צרו רצף תרגול נשימה משלכם, שלבו כמה שלבים במפגש אחד זורם, התאימו צלילים וסימנים, ושתפו תרגולים עם אחרים.",
        "summary": "Vritti היא אפליקציית תרגול נשימה למי שמחפשים רוגע, מיקוד ושגרה יומית מודעת יותר.",
        "details": "צרו את זרימת התרגול האישית שלכם על ידי שילוב של כמה תרגילי נשימה, מקטעי מדיטציה ומפגשים קצביים לרצף אחד חלק. בין אם אתם רוצים איפוס קצר, שגרת פראניאמה מובנית או מפגש ארוך יותר שנבנה לפי השיטה האישית שלכם, Vritti נותנת לכם את הכלים לעצב אותו בדרך שלכם. שמרו שלבים מותאמים כתבניות כדי לבנות תרגולים חדשים מהר יותר.",
        "features": [
          "צרו והפעילו רצפים מותאמים אישית של תרגולים",
          "כווננו במדויק את התזמון ואת שאר ההגדרות כך שהתרגול יתאים לכם",
          "שמרו שלבים מותאמים כתבניות כדי לבנות תרגולים חדשים מהר יותר",
          "התחילו במהירות עם מצבים מוכנים לשימוש ותרגולים מומלצים",
          "גלו אוסף עשיר יותר של צלילים לחוויה סוחפת יותר",
          "שתפו את התרגולים שלכם עם חברים, תלמידים או לקוחות",
          "הישארו מודרכים בעזרת סימנים חזותיים, קוליים והפטיים ברורים",
          "תרגלו בממשק נקי ואינטואיטיבי עם תמיכה בריבוי שפות"
        ],
        "closing": "פותחה בתמיכה מתודולוגית של המכון לשיטות מזרחיות לשיקום."
      }
    }
  },
  "hi": {
    "translation": {
      "meta": {
        "appName": "वृत्ति",
        "badge": "श्वास और प्राणायाम",
        "dir": "ltr"
      },
      "landing": {
        "heroTitle": "अपनी श्वास-प्रैक्टिस बनाने का अधिक शांत तरीका।",
        "featuresTitle": "Vritti क्यों",
        "galleryTitle": "ऐप के अंदर",
        "closingTitle": "अपनी अगली प्रैक्टिस Vritti के साथ शुरू करें।",
        "languageLabel": "भाषा",
        "themeLabel": "थीम",
        "themeSystem": "ऑटो",
        "themeLight": "हल्का",
        "themeDark": "गहरा",
        "instituteName": "इंस्टीट्यूट ऑफ ईस्टर्न मेथड्स ऑफ रिहैबिलिटेशन",
        "footerNoteBefore": "",
        "footerNoteAfter": " के पद्धतिगत सहयोग से विकसित।",
        "appStoreBadgeAlt": "App Store पर डाउनलोड करें",
        "googlePlayBadgeAlt": "Google Play पर उपलब्ध"
      },
      "freediving": {
        "metaTitle": "फ्रीडाइविंग के लिए Vritti | ड्राई एप्निया अभ्यास ऐप",
        "metaDescription": "जमीन पर ड्राई एप्निया अभ्यास के लिए Vritti का उपयोग करें। लचीले टाइमिंग, संकेतों, रिमाइंडर, विजेट और सेव की गई रूटीन के साथ कस्टम ब्रीथ-होल्ड और ब्रीदिंग सेशन बनाएं।",
        "navLabel": "फ्रीडाइविंग पेज",
        "navWhy": "यह क्यों उपयोगी है",
        "navScreenshots": "स्क्रीनशॉट",
        "navPrivacy": "प्राइवेसी",
        "mainPageCta": "मुख्य Vritti पेज देखें",
        "heroKicker": "ड्राई एप्निया अभ्यास के लिए फ्रीडाइविंग ऐप",
        "heroTitle": "संरचित ड्राई एप्निया अभ्यास, सरल तरीके से",
        "heroText": "लचीले टाइमिंग, संकेतों, रिमाइंडर, विजेट और सेव की गई रूटीन के साथ कस्टम ब्रीथ-होल्ड और ब्रीदिंग सेशन बनाएं।",
        "heroNote": "जमीन पर ड्राई अभ्यास के लिए सबसे उपयुक्त।",
        "whyKicker": "ड्राई अभ्यास की संरचना",
        "whyTitle": "फ्रीडाइवर इसे उपयोगी क्यों पा सकते हैं",
        "whyText": "Vritti जमीन पर ब्रीथ-होल्ड अभ्यास के लिए एक लचीला एप्निया ऐप और ब्रीथ-होल्ड टाइमर है, जिसमें दोहराने योग्य ड्राई अभ्यास सेशन बनाने के टूल हैं।",
        "benefits": [
          "कस्टम मल्टी-स्टेज सेशन बनाएं",
          "अपनी ड्राई अभ्यास संरचना के अनुसार टाइमिंग बदलें",
          "साउंड, हैप्टिक और विजुअल संकेत इस्तेमाल करें",
          "रूटीन सेव करें और उन्हें नियमित रूप से दोहराएं",
          "विजेट और रिमाइंडर से अभ्यास जल्दी शुरू करें"
        ],
        "featuresKicker": "फ़ीचर",
        "featuresTitle": "लचीला टाइमिंग और दोहराने योग्य रूटीन",
        "screenshotCaptions": [
          "अपना एप्निया सेशन बनाएं",
          "जमीन पर ड्राई ब्रीथ-होल्ड अभ्यास",
          "लचीला टाइमिंग और संकेत",
          "नियमितता के लिए विजेट और रिमाइंडर",
          "दोहराने के लिए रूटीन सेव करें",
          "सरल इंटरफ़ेस। सटीक नियंत्रण।"
        ],
        "designedTitle": "Vritti किसके लिए बनाया गया है",
        "designedText": "Vritti एक लचीला ब्रीदिंग अभ्यास ऐप है, जो जमीन पर ड्राई ब्रीथ-होल्ड संरचना और ब्रीदिंग कार्य के लिए उपयोगी हो सकता है।",
        "notTitle": "यह क्या नहीं है",
        "notText": "यह कोचिंग, पानी में निगरानी, बडी प्रक्रियाओं या फ्रीडाइविंग सुरक्षा प्रशिक्षण का विकल्प नहीं है।",
        "useKicker": "व्यावहारिक उपयोग",
        "useTitle": "संभावित उपयोग",
        "useCases": [
          "ड्राई ब्रीथ-होल्ड टाइमिंग",
          "अभ्यास से पहले शांत करने वाली ब्रीदिंग",
          "सरल एप्निया सेशन संरचना",
          "ट्रेनिंग सेशन के बीच निजी ब्रीदिंग रूटीन"
        ],
        "trustKicker": "विश्वास",
        "trustTitle": "सरल और प्राइवेसी-फ्रेंडली",
        "trustPoints": [
          "iPhone और Android पर उपलब्ध",
          "कई इंटरफ़ेस भाषाओं का समर्थन करता है",
          "App Store लिस्टिंग के अनुसार डेटा एकत्र नहीं किया जाता"
        ],
        "privacyLink": "प्राइवेसी पॉलिसी पढ़ें",
        "finalKicker": "मुफ़्त में आज़माएं",
        "finalTitle": "ड्राई अभ्यास के लिए Vritti आज़माएं",
        "finalText": "यदि आप जमीन पर ब्रीथ-होल्ड और ब्रीदिंग सेशन को संरचित करने का सरल तरीका चाहते हैं, तो Vritti मुफ़्त में आज़माया जा सकता है।",
        "safetyNote": "Vritti का उपयोग केवल जमीन पर ड्राई अभ्यास के लिए करें। यह फ्रीडाइविंग कोच, सुरक्षा प्रणाली, पानी में प्रशिक्षण ऐप या निर्देश और बडी प्रक्रियाओं का विकल्प नहीं है।"
      },
      "support": {
        "metaTitle": "Support Vritti | Feedback & Ratings",
        "metaDescription": "Share feedback, rate Vritti, and support the free breathing practice app.",
        "title": "Support Vritti",
        "intro": "Vritti is completely free. If it helps your practice, the best ways to support it are a quick rating, honest feedback — or simply telling a friend.",
        "feedbackTitle": "Send feedback",
        "feedbackIntro": "Found a bug, missing a feature, or just want to say hi? We read every message.",
        "messageLabel": "Your message",
        "messagePlaceholder": "What's on your mind?",
        "emailLabel": "Reply email (optional)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Please enter a valid email address or leave the field empty.",
        "messageRequired": "Please write a message first.",
        "send": "Send feedback",
        "sending": "Sending…",
        "success": "Thank you! Your feedback has been sent.",
        "error": "Could not send feedback right now. Please try again in a few minutes.",
        "rateTitle": "Rate the app",
        "rateIntro": "Ratings help other people find Vritti. It takes less than a minute.",
        "rateAppStore": "Rate on the App Store",
        "rateGooglePlay": "Rate on Google Play",
        "donateTitle": "Leave a donation",
        "donateIntro": "If you'd like to support Vritti's development with a small gift, you can do so below. Everything stays optional — the app is and will remain free.",
        "donateButton": "Support on Ko-fi",
        "backHome": "Back to the main page"
      },
      "content": {
        "promoText": "अपना खुद का श्वास-अभ्यास प्रवाह बनाएं, कई चरणों को एक सहज सत्र में जोड़ें, ध्वनियों और संकेतों को अनुकूलित करें, और अभ्यास दूसरों के साथ साझा करें।",
        "summary": "Vritti श्वास-अभ्यास को शांति, एकाग्रता और संतुलन के लिए एक सरल दैनिक आदत बना देती है।",
        "details": "श्वास अभ्यास, ध्यान खंड और लयबद्ध सत्रों को जोड़कर अपना अभ्यास-प्रवाह तैयार कीजिए। अनुशंसित सत्रों से शुरुआत कीजिए, समय और सेटिंग्स को अपनी ज़रूरत के अनुसार बदलिए, मन के मुताबिक ध्वनियाँ चुनिए और अपने अभ्यास दूसरों के साथ साझा कीजिए। नई प्रैक्टिस तेज़ी से बनाने के लिए अपने कस्टम चरणों को टेम्पलेट के रूप में सहेजें।",
        "features": [
          "अपने अभ्यास-क्रम बनाइए और चलाइए",
          "हर अभ्यास को लचीली सेटिंग्स से अपने अनुसार ढालिए",
          "नई प्रैक्टिस तेज़ी से बनाने के लिए अपने कस्टम चरणों को टेम्पलेट के रूप में सहेजें",
          "तैयार और अनुशंसित सत्रों के साथ जल्दी शुरुआत कीजिए",
          "ध्वनि, दृश्य संकेत और हैप्टिक मार्गदर्शन के साथ अधिक गहरा अनुभव पाइए",
          "अपने अभ्यास दोस्तों, विद्यार्थियों या क्लाइंट्स के साथ साझा कीजिए",
          "साफ़ और सहज इंटरफ़ेस में अभ्यास कीजिए"
        ],
        "closing": "शुरुआती और अनुभवी, दोनों के लिए उपयुक्त।\nइंस्टीट्यूट ऑफ ईस्टर्न मेथड्स ऑफ रिहैबिलिटेशन के पद्धतिगत सहयोग से विकसित।"
      }
    }
  },
  "id": {
    "translation": {
      "meta": {
        "appName": "Vritti",
        "badge": "Napas & pranayama",
        "dir": "ltr"
      },
      "landing": {
        "heroTitle": "Cara yang lebih tenang untuk menyusun latihan pernapasanmu.",
        "featuresTitle": "Mengapa Vritti",
        "galleryTitle": "Di dalam aplikasi",
        "closingTitle": "Mulai latihan berikutnya dengan Vritti.",
        "languageLabel": "Bahasa",
        "themeLabel": "Tema",
        "themeSystem": "Otomatis",
        "themeLight": "Terang",
        "themeDark": "Gelap",
        "instituteName": "Institute of Eastern Methods of Rehabilitation",
        "footerNoteBefore": "Dikembangkan dengan dukungan metodologis dari ",
        "footerNoteAfter": ".",
        "appStoreBadgeAlt": "Unduh di App Store",
        "googlePlayBadgeAlt": "Tersedia di Google Play"
      },
      "freediving": {
        "metaTitle": "Vritti untuk Freediving | Aplikasi Latihan Apnea Kering",
        "metaDescription": "Gunakan Vritti untuk latihan apnea kering di darat. Buat sesi tahan napas dan pernapasan kustom dengan pengaturan waktu fleksibel, isyarat, pengingat, widget, dan rutinitas tersimpan.",
        "navLabel": "Halaman freediving",
        "navWhy": "Mengapa berguna",
        "navScreenshots": "Screenshot",
        "navPrivacy": "Privasi",
        "mainPageCta": "Lihat halaman utama Vritti",
        "heroKicker": "Aplikasi freediving untuk latihan apnea kering",
        "heroTitle": "Latihan apnea kering yang terstruktur dan sederhana",
        "heroText": "Buat sesi tahan napas dan pernapasan kustom dengan pengaturan waktu fleksibel, isyarat, pengingat, widget, dan rutinitas tersimpan.",
        "heroNote": "Paling cocok untuk latihan kering di darat.",
        "whyKicker": "Struktur latihan kering",
        "whyTitle": "Mengapa freediver mungkin merasa ini berguna",
        "whyText": "Vritti adalah aplikasi apnea fleksibel dan timer tahan napas untuk latihan tahan napas di darat, dengan alat untuk membuat sesi latihan kering yang dapat diulang.",
        "benefits": [
          "Buat sesi kustom multi-tahap",
          "Sesuaikan waktu dengan struktur latihan kering Anda",
          "Gunakan isyarat suara, haptik, dan visual",
          "Simpan rutinitas dan ulangi secara konsisten",
          "Mulai latihan lebih cepat dengan widget dan pengingat"
        ],
        "featuresKicker": "Fitur",
        "featuresTitle": "Waktu fleksibel dan rutinitas yang dapat diulang",
        "screenshotCaptions": [
          "Buat sesi apnea Anda sendiri",
          "Latihan tahan napas kering di darat",
          "Waktu dan isyarat fleksibel",
          "Widget dan pengingat untuk konsistensi",
          "Simpan rutinitas untuk latihan berulang",
          "Antarmuka sederhana. Kontrol presisi."
        ],
        "designedTitle": "Untuk apa Vritti dirancang",
        "designedText": "Vritti adalah aplikasi latihan pernapasan fleksibel yang dapat membantu menyusun latihan tahan napas kering dan kerja napas di darat.",
        "notTitle": "Yang bukan fungsi Vritti",
        "notText": "Ini bukan pengganti coaching, pengawasan di air, prosedur buddy, atau pelatihan keselamatan freediving.",
        "useKicker": "Penggunaan praktis",
        "useTitle": "Kemungkinan penggunaan",
        "useCases": [
          "Pengaturan waktu tahan napas kering",
          "Pernapasan menenangkan sebelum latihan",
          "Struktur sederhana untuk sesi apnea",
          "Rutinitas pernapasan pribadi di antara sesi latihan"
        ],
        "trustKicker": "Kepercayaan",
        "trustTitle": "Sederhana dan ramah privasi",
        "trustPoints": [
          "Tersedia di iPhone dan Android",
          "Mendukung banyak bahasa antarmuka",
          "Tidak ada data yang dikumpulkan, menurut listing App Store"
        ],
        "privacyLink": "Baca kebijakan privasi",
        "finalKicker": "Gratis untuk dicoba",
        "finalTitle": "Coba Vritti untuk latihan kering",
        "finalText": "Jika Anda ingin cara sederhana untuk menyusun sesi tahan napas dan pernapasan di darat, Vritti gratis untuk dicoba.",
        "safetyNote": "Gunakan Vritti hanya untuk latihan kering di darat. Ini bukan pelatih freediving, sistem keselamatan, aplikasi latihan di air, atau pengganti instruksi dan prosedur buddy."
      },
      "support": {
        "metaTitle": "Support Vritti | Feedback & Ratings",
        "metaDescription": "Share feedback, rate Vritti, and support the free breathing practice app.",
        "title": "Support Vritti",
        "intro": "Vritti is completely free. If it helps your practice, the best ways to support it are a quick rating, honest feedback — or simply telling a friend.",
        "feedbackTitle": "Send feedback",
        "feedbackIntro": "Found a bug, missing a feature, or just want to say hi? We read every message.",
        "messageLabel": "Your message",
        "messagePlaceholder": "What's on your mind?",
        "emailLabel": "Reply email (optional)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Please enter a valid email address or leave the field empty.",
        "messageRequired": "Please write a message first.",
        "send": "Send feedback",
        "sending": "Sending…",
        "success": "Thank you! Your feedback has been sent.",
        "error": "Could not send feedback right now. Please try again in a few minutes.",
        "rateTitle": "Rate the app",
        "rateIntro": "Ratings help other people find Vritti. It takes less than a minute.",
        "rateAppStore": "Rate on the App Store",
        "rateGooglePlay": "Rate on Google Play",
        "donateTitle": "Leave a donation",
        "donateIntro": "If you'd like to support Vritti's development with a small gift, you can do so below. Everything stays optional — the app is and will remain free.",
        "donateButton": "Support on Ko-fi",
        "backHome": "Back to the main page"
      },
      "content": {
        "promoText": "Buat alur latihan napas Anda sendiri, gabungkan beberapa tahap dalam satu sesi yang mulus, atur suara dan isyarat, lalu bagikan rutinitas dengan orang lain.",
        "summary": "Vritti adalah aplikasi latihan pernapasan untuk orang-orang yang mencari ketenangan, fokus, dan rutinitas harian yang lebih sadar.",
        "details": "Buat alur latihan Anda sendiri dengan menggabungkan beberapa latihan pernapasan, blok meditasi, dan sesi ritmis menjadi satu rangkaian yang mulus. Baik Anda menginginkan reset singkat, rutinitas pranayama yang terstruktur, atau sesi yang lebih panjang berdasarkan metode pribadi Anda, Vritti memberi Anda alat untuk membentuknya dengan cara Anda sendiri. Simpan tahap kustom sebagai template untuk membuat latihan baru lebih cepat.",
        "features": [
          "Buat dan jalankan rangkaian latihan yang dipersonalisasi",
          "Sesuaikan waktu dan pengaturan lainnya agar latihan benar-benar pas untuk Anda",
          "Simpan tahap kustom sebagai template untuk membuat latihan baru lebih cepat",
          "Mulai lebih cepat dengan mode siap pakai dan latihan yang direkomendasikan",
          "Jelajahi koleksi suara yang lebih kaya untuk pengalaman yang lebih imersif",
          "Bagikan latihan Anda dengan teman, murid, atau klien",
          "Tetap terpandu dengan isyarat visual, audio, dan haptik yang jelas",
          "Berlatih dalam antarmuka yang bersih dan intuitif dengan dukungan multibahasa"
        ],
        "closing": "Dikembangkan dengan dukungan metodologis dari Institute of Eastern Methods of Rehabilitation."
      }
    }
  },
  "ja": {
    "translation": {
      "meta": {
        "appName": "心の波",
        "badge": "呼吸法とプラーナヤーマ",
        "dir": "ltr"
      },
      "landing": {
        "heroTitle": "呼吸の練習を、自分らしく静かに整える方法。",
        "featuresTitle": "Vrittiが選ばれる理由",
        "galleryTitle": "アプリの中身",
        "closingTitle": "次の練習をVrittiで始めましょう。",
        "languageLabel": "言語",
        "themeLabel": "テーマ",
        "themeSystem": "自動",
        "themeLight": "ライト",
        "themeDark": "ダーク",
        "instituteName": "東洋リハビリテーション方法研究所",
        "footerNoteBefore": "",
        "footerNoteAfter": "の方法論的支援を受けて開発されました。",
        "appStoreBadgeAlt": "App Storeでダウンロード",
        "googlePlayBadgeAlt": "Google Playで手に入れよう"
      },
      "freediving": {
        "metaTitle": "フリーダイビング向けVritti | ドライアプネア練習アプリ",
        "metaDescription": "陸上でのドライアプネア練習にVrittiを使えます。柔軟なタイミング、合図、リマインダー、ウィジェット、保存済みルーティンで、息止めと呼吸のセッションを組み立てられます。",
        "navLabel": "フリーダイビングページ",
        "navWhy": "役立つ理由",
        "navScreenshots": "スクリーンショット",
        "navPrivacy": "プライバシー",
        "mainPageCta": "Vrittiのメインページを見る",
        "heroKicker": "ドライアプネア練習のためのフリーダイビングアプリ",
        "heroTitle": "構造化されたドライアプネア練習をシンプルに",
        "heroText": "柔軟なタイミング、合図、リマインダー、ウィジェット、保存済みルーティンで、息止めと呼吸のセッションを組み立てられます。",
        "heroNote": "陸上でのドライ練習に適しています。",
        "whyKicker": "ドライ練習の構成",
        "whyTitle": "フリーダイバーに役立つかもしれない理由",
        "whyText": "Vrittiは、陸上での息止め練習に使える柔軟なアプネアアプリ兼ブレスホールドタイマーです。繰り返し使えるドライ練習セッションを作るためのツールがあります。",
        "benefits": [
          "複数ステージのカスタムセッションを作成",
          "自分のドライ練習構成に合わせてタイミングを調整",
          "音、触覚、視覚の合図を使用",
          "ルーティンを保存して継続的に繰り返す",
          "ウィジェットとリマインダーで練習をすばやく開始"
        ],
        "featuresKicker": "機能",
        "featuresTitle": "柔軟なタイミングと繰り返せるルーティン",
        "screenshotCaptions": [
          "自分のアプネアセッションを作成",
          "陸上でのドライブレスホールド練習",
          "柔軟なタイミングと合図",
          "継続のためのウィジェットとリマインダー",
          "繰り返し用のルーティンを保存",
          "シンプルな画面。正確なコントロール。"
        ],
        "designedTitle": "Vrittiが想定している用途",
        "designedText": "Vrittiは柔軟な呼吸練習アプリで、陸上でのドライ息止めの構成や呼吸ワークに役立つ場合があります。",
        "notTitle": "Vrittiではないもの",
        "notText": "コーチング、水中での監督、バディ手順、フリーダイビングの安全講習の代わりにはなりません。",
        "useKicker": "実用例",
        "useTitle": "考えられる使い方",
        "useCases": [
          "ドライ息止めのタイミング",
          "練習前の落ち着く呼吸ワーク",
          "シンプルなアプネアセッション構成",
          "トレーニング間の個人用呼吸ルーティン"
        ],
        "trustKicker": "信頼",
        "trustTitle": "シンプルでプライバシーに配慮",
        "trustPoints": [
          "iPhoneとAndroidで利用可能",
          "多くのインターフェース言語に対応",
          "App Storeの表示によるとデータは収集されません"
        ],
        "privacyLink": "プライバシーポリシーを読む",
        "finalKicker": "無料で試せます",
        "finalTitle": "ドライ練習にVrittiを試す",
        "finalText": "陸上での息止めと呼吸セッションをシンプルに構成したいなら、Vrittiは無料で試せます。",
        "safetyNote": "Vrittiは陸上でのドライ練習にのみ使用してください。フリーダイビングのコーチ、安全システム、水中トレーニングアプリ、指導やバディ手順の代替ではありません。"
      },
      "support": {
        "metaTitle": "Support Vritti | Feedback & Ratings",
        "metaDescription": "Share feedback, rate Vritti, and support the free breathing practice app.",
        "title": "Support Vritti",
        "intro": "Vritti is completely free. If it helps your practice, the best ways to support it are a quick rating, honest feedback — or simply telling a friend.",
        "feedbackTitle": "Send feedback",
        "feedbackIntro": "Found a bug, missing a feature, or just want to say hi? We read every message.",
        "messageLabel": "Your message",
        "messagePlaceholder": "What's on your mind?",
        "emailLabel": "Reply email (optional)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Please enter a valid email address or leave the field empty.",
        "messageRequired": "Please write a message first.",
        "send": "Send feedback",
        "sending": "Sending…",
        "success": "Thank you! Your feedback has been sent.",
        "error": "Could not send feedback right now. Please try again in a few minutes.",
        "rateTitle": "Rate the app",
        "rateIntro": "Ratings help other people find Vritti. It takes less than a minute.",
        "rateAppStore": "Rate on the App Store",
        "rateGooglePlay": "Rate on Google Play",
        "donateTitle": "Leave a donation",
        "donateIntro": "If you'd like to support Vritti's development with a small gift, you can do so below. Everything stays optional — the app is and will remain free.",
        "donateButton": "Support on Ko-fi",
        "backHome": "Back to the main page"
      },
      "content": {
        "promoText": "自分だけの呼吸フローを作成し、複数のステージを1つのスムーズなセッションにまとめ、音や合図を調整して、練習をほかの人と共有できます。",
        "summary": "Vrittiは、呼吸の時間を、落ち着きと集中、そして心身を整えるためのシンプルな毎日の習慣に変えるアプリです。",
        "details": "呼吸エクササイズ、瞑想ブロック、リズムセッションを組み合わせて、自分だけの練習フローを作れます。おすすめのセッションからすぐに始めて、時間や設定を細かく調整し、その日の気分に合う音を選び、練習内容をほかの人と共有できます。カスタムステップをテンプレートとして保存し、新しい練習をすばやく作成。",
        "features": [
          "オリジナルの練習シーケンスを作成して再生",
          "柔軟な設定で練習を自分向けに調整",
          "カスタムステップをテンプレートとして保存し、新しい練習をすばやく作成",
          "用意されたセッションやおすすめの練習ですぐに開始",
          "音、ビジュアル、触覚ガイドでより没入できる体験",
          "友人、受講者、クライアントと練習を共有",
          "すっきりと使いやすい画面で集中して続けられる"
        ],
        "closing": "初心者にも、経験者にも。\n東洋リハビリテーション方法研究所の方法論的支援を受けて開発されました。"
      }
    }
  },
  "ko": {
    "translation": {
      "meta": {
        "appName": "마음의 파동",
        "badge": "호흡과 프라나야마",
        "dir": "ltr"
      },
      "landing": {
        "heroTitle": "호흡 연습을 더 차분하게 구성하는 방법.",
        "featuresTitle": "왜 Vritti인가",
        "galleryTitle": "앱 안에서 보기",
        "closingTitle": "다음 연습을 Vritti와 함께 시작하세요.",
        "languageLabel": "언어",
        "themeLabel": "테마",
        "themeSystem": "자동",
        "themeLight": "라이트",
        "themeDark": "다크",
        "instituteName": "동양 재활 방법 연구소",
        "footerNoteBefore": "",
        "footerNoteAfter": "의 방법론적 지원을 받아 개발되었습니다.",
        "appStoreBadgeAlt": "App Store에서 다운로드",
        "googlePlayBadgeAlt": "Google Play에서 받기"
      },
      "freediving": {
        "metaTitle": "프리다이빙을 위한 Vritti | 드라이 아프네아 연습 앱",
        "metaDescription": "육상에서의 드라이 아프네아 연습에 Vritti를 사용하세요. 유연한 타이밍, 신호, 리마인더, 위젯, 저장된 루틴으로 맞춤 숨참기 및 호흡 세션을 만들 수 있습니다.",
        "navLabel": "프리다이빙 페이지",
        "navWhy": "도움이 되는 이유",
        "navScreenshots": "스크린샷",
        "navPrivacy": "개인정보",
        "mainPageCta": "Vritti 메인 페이지 보기",
        "heroKicker": "드라이 아프네아 연습을 위한 프리다이빙 앱",
        "heroTitle": "구조화된 드라이 아프네아 연습을 간단하게",
        "heroText": "유연한 타이밍, 신호, 리마인더, 위젯, 저장된 루틴으로 맞춤 숨참기 및 호흡 세션을 만들 수 있습니다.",
        "heroNote": "육상에서의 드라이 연습에 가장 적합합니다.",
        "whyKicker": "드라이 연습 구조",
        "whyTitle": "프리다이버에게 유용할 수 있는 이유",
        "whyText": "Vritti는 육상 숨참기 훈련을 위한 유연한 아프네아 앱이자 숨참기 타이머로, 반복 가능한 드라이 연습 세션을 만드는 도구를 제공합니다.",
        "benefits": [
          "맞춤형 다단계 세션 만들기",
          "자신의 드라이 연습 구조에 맞게 타이밍 조정",
          "소리, 햅틱, 시각 신호 사용",
          "루틴을 저장하고 꾸준히 반복",
          "위젯과 리마인더로 더 빠르게 연습 시작"
        ],
        "featuresKicker": "기능",
        "featuresTitle": "유연한 타이밍과 반복 가능한 루틴",
        "screenshotCaptions": [
          "나만의 아프네아 세션 만들기",
          "육상 드라이 숨참기 연습",
          "유연한 타이밍과 신호",
          "꾸준함을 위한 위젯과 리마인더",
          "반복 연습을 위해 루틴 저장",
          "간단한 인터페이스. 정밀한 제어."
        ],
        "designedTitle": "Vritti가 설계된 목적",
        "designedText": "Vritti는 육상에서의 드라이 숨참기 구조와 호흡 작업에 유용할 수 있는 유연한 호흡 연습 앱입니다.",
        "notTitle": "Vritti가 아닌 것",
        "notText": "코칭, 수중 감독, 버디 절차 또는 프리다이빙 안전 교육을 대체하지 않습니다.",
        "useKicker": "실용적 사용",
        "useTitle": "가능한 사용 예",
        "useCases": [
          "드라이 숨참기 타이밍",
          "연습 전 진정 호흡",
          "간단한 아프네아 세션 구조",
          "훈련 세션 사이의 개인 호흡 루틴"
        ],
        "trustKicker": "신뢰",
        "trustTitle": "간단하고 개인정보 친화적",
        "trustPoints": [
          "iPhone 및 Android에서 사용 가능",
          "여러 인터페이스 언어 지원",
          "App Store 목록에 따르면 데이터가 수집되지 않음"
        ],
        "privacyLink": "개인정보 처리방침 읽기",
        "finalKicker": "무료로 체험",
        "finalTitle": "드라이 연습에 Vritti를 사용해 보세요",
        "finalText": "육상에서 숨참기와 호흡 세션을 간단하게 구성하고 싶다면 Vritti를 무료로 사용해 볼 수 있습니다.",
        "safetyNote": "Vritti는 육상 드라이 연습에만 사용하세요. 프리다이빙 코치, 안전 시스템, 수중 훈련 앱 또는 교육과 버디 절차의 대체물이 아닙니다."
      },
      "support": {
        "metaTitle": "Support Vritti | Feedback & Ratings",
        "metaDescription": "Share feedback, rate Vritti, and support the free breathing practice app.",
        "title": "Support Vritti",
        "intro": "Vritti is completely free. If it helps your practice, the best ways to support it are a quick rating, honest feedback — or simply telling a friend.",
        "feedbackTitle": "Send feedback",
        "feedbackIntro": "Found a bug, missing a feature, or just want to say hi? We read every message.",
        "messageLabel": "Your message",
        "messagePlaceholder": "What's on your mind?",
        "emailLabel": "Reply email (optional)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Please enter a valid email address or leave the field empty.",
        "messageRequired": "Please write a message first.",
        "send": "Send feedback",
        "sending": "Sending…",
        "success": "Thank you! Your feedback has been sent.",
        "error": "Could not send feedback right now. Please try again in a few minutes.",
        "rateTitle": "Rate the app",
        "rateIntro": "Ratings help other people find Vritti. It takes less than a minute.",
        "rateAppStore": "Rate on the App Store",
        "rateGooglePlay": "Rate on Google Play",
        "donateTitle": "Leave a donation",
        "donateIntro": "If you'd like to support Vritti's development with a small gift, you can do so below. Everything stays optional — the app is and will remain free.",
        "donateButton": "Support on Ko-fi",
        "backHome": "Back to the main page"
      },
      "content": {
        "promoText": "나만의 호흡 연습 흐름을 만들고, 여러 단계를 하나의 매끄러운 세션으로 묶고, 소리와 신호를 조정하고, 연습 루틴을 다른 사람과 공유하세요.",
        "summary": "Vritti는 호흡 수련을 차분함과 집중, 회복을 위한 간단한 일상 습관으로 바꿔주는 앱입니다.",
        "details": "호흡 연습, 명상 블록, 리듬 세션을 하나의 자연스러운 흐름으로 묶어 나만의 수련 플로우를 만들 수 있습니다. 추천 세션으로 바로 시작하고, 시간과 설정을 세밀하게 조정하고, 내 상태에 맞는 사운드를 고르고, 수련을 다른 사람과 나눠 보세요. 커스텀 단계를 템플릿으로 저장해 새로운 수련을 더 빠르게 만드세요.",
        "features": [
          "나만의 수련 시퀀스를 만들고 재생할 수 있습니다",
          "유연한 설정으로 각 수련을 내 방식에 맞게 조정할 수 있습니다",
          "커스텀 단계를 템플릿으로 저장해 새로운 수련을 더 빠르게 만드세요",
          "준비된 세션과 추천 수련으로 빠르게 시작할 수 있습니다",
          "사운드, 시각 가이드, 햅틱 신호로 더 몰입감 있게 수련할 수 있습니다",
          "친구, 수강생, 고객과 수련을 공유할 수 있습니다",
          "깔끔하고 직관적인 화면에서 편하게 이어갈 수 있습니다"
        ],
        "closing": "처음 시작하는 사람에게도, 경험 많은 수련자에게도 잘 맞습니다.\n동양 재활 방법 연구소의 방법론적 지원을 받아 개발되었습니다."
      }
    }
  },
  "tr": {
    "translation": {
      "meta": {
        "appName": "Vritti",
        "badge": "Nefes ve pranayama",
        "dir": "ltr"
      },
      "landing": {
        "heroTitle": "Nefes pratiğini kurmanın daha sakin bir yolu.",
        "featuresTitle": "Neden Vritti",
        "galleryTitle": "Uygulamanın içinde",
        "closingTitle": "Bir sonraki pratiğine Vritti ile başla.",
        "languageLabel": "Dil",
        "themeLabel": "Tema",
        "themeSystem": "Otomatik",
        "themeLight": "Açık",
        "themeDark": "Koyu",
        "instituteName": "Doğu Rehabilitasyon Yöntemleri Enstitüsü",
        "footerNoteBefore": "",
        "footerNoteAfter": "'nün metodolojik desteğiyle geliştirilmiştir.",
        "appStoreBadgeAlt": "App Store’dan indirin",
        "googlePlayBadgeAlt": "Google Play’den edinin"
      },
      "freediving": {
        "metaTitle": "Serbest Dalış için Vritti | Kuru Apnea Pratiği Uygulaması",
        "metaDescription": "Karada kuru apnea pratiği için Vritti’yi kullanın. Esnek zamanlama, işaretler, hatırlatıcılar, widget’lar ve kayıtlı rutinlerle özel nefes tutma ve nefes seansları oluşturun.",
        "navLabel": "Serbest dalış sayfası",
        "navWhy": "Neden yardımcı olur",
        "navScreenshots": "Ekran görüntüleri",
        "navPrivacy": "Gizlilik",
        "mainPageCta": "Ana Vritti sayfasını gör",
        "heroKicker": "Kuru apnea pratiği için serbest dalış uygulaması",
        "heroTitle": "Yapılandırılmış kuru apnea pratiği, sadeleştirildi",
        "heroText": "Esnek zamanlama, işaretler, hatırlatıcılar, widget’lar ve kayıtlı rutinlerle özel nefes tutma ve nefes seansları oluşturun.",
        "heroNote": "Karada kuru pratik için en uygunudur.",
        "whyKicker": "Kuru pratik yapısı",
        "whyTitle": "Serbest dalıcılar neden faydalı bulabilir",
        "whyText": "Vritti, karada nefes tutma çalışması için esnek bir apnea uygulaması ve nefes tutma zamanlayıcısıdır; tekrarlanabilir kuru pratik seansları oluşturmak için araçlar sunar.",
        "benefits": [
          "Özel çok aşamalı seanslar oluşturun",
          "Zamanlamayı kendi kuru pratik yapınıza göre ayarlayın",
          "Sesli, dokunsal ve görsel işaretler kullanın",
          "Rutinleri kaydedin ve düzenli olarak tekrarlayın",
          "Widget’lar ve hatırlatıcılarla pratiği daha hızlı başlatın"
        ],
        "featuresKicker": "Özellikler",
        "featuresTitle": "Esnek zamanlama ve tekrarlanabilir rutinler",
        "screenshotCaptions": [
          "Kendi apnea seansınızı oluşturun",
          "Karada kuru nefes tutma pratiği",
          "Esnek zamanlama ve işaretler",
          "Düzenlilik için widget’lar ve hatırlatıcılar",
          "Tekrar için rutinleri kaydedin",
          "Basit arayüz. Hassas kontrol."
        ],
        "designedTitle": "Vritti ne için tasarlandı",
        "designedText": "Vritti, karada kuru nefes tutma yapısı ve nefes çalışması için faydalı olabilecek esnek bir nefes pratiği uygulamasıdır.",
        "notTitle": "Ne değildir",
        "notText": "Koçluğun, suda gözetimin, buddy prosedürlerinin veya serbest dalış güvenlik eğitiminin yerine geçmez.",
        "useKicker": "Pratik kullanım",
        "useTitle": "Olası kullanımlar",
        "useCases": [
          "Kuru nefes tutma zamanlaması",
          "Pratik öncesi sakinleştirici nefes çalışması",
          "Basit apnea seansı yapısı",
          "Antrenmanlar arasında kişisel nefes rutinleri"
        ],
        "trustKicker": "Güven",
        "trustTitle": "Basit ve gizlilik dostu",
        "trustPoints": [
          "iPhone ve Android’de kullanılabilir",
          "Birçok arayüz dilini destekler",
          "App Store kaydına göre veri toplanmaz"
        ],
        "privacyLink": "Gizlilik politikasını oku",
        "finalKicker": "Ücretsiz deneyin",
        "finalTitle": "Kuru pratik için Vritti’yi deneyin",
        "finalText": "Karada nefes tutma ve nefes seanslarını yapılandırmanın basit bir yolunu istiyorsanız, Vritti’yi ücretsiz deneyebilirsiniz.",
        "safetyNote": "Vritti’yi yalnızca karada kuru pratik için kullanın. Serbest dalış koçu, güvenlik sistemi, suda antrenman uygulaması veya eğitim ve buddy prosedürlerinin yerine geçen bir araç değildir."
      },
      "support": {
        "metaTitle": "Support Vritti | Feedback & Ratings",
        "metaDescription": "Share feedback, rate Vritti, and support the free breathing practice app.",
        "title": "Support Vritti",
        "intro": "Vritti is completely free. If it helps your practice, the best ways to support it are a quick rating, honest feedback — or simply telling a friend.",
        "feedbackTitle": "Send feedback",
        "feedbackIntro": "Found a bug, missing a feature, or just want to say hi? We read every message.",
        "messageLabel": "Your message",
        "messagePlaceholder": "What's on your mind?",
        "emailLabel": "Reply email (optional)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Please enter a valid email address or leave the field empty.",
        "messageRequired": "Please write a message first.",
        "send": "Send feedback",
        "sending": "Sending…",
        "success": "Thank you! Your feedback has been sent.",
        "error": "Could not send feedback right now. Please try again in a few minutes.",
        "rateTitle": "Rate the app",
        "rateIntro": "Ratings help other people find Vritti. It takes less than a minute.",
        "rateAppStore": "Rate on the App Store",
        "rateGooglePlay": "Rate on Google Play",
        "donateTitle": "Leave a donation",
        "donateIntro": "If you'd like to support Vritti's development with a small gift, you can do so below. Everything stays optional — the app is and will remain free.",
        "donateButton": "Support on Ko-fi",
        "backHome": "Back to the main page"
      },
      "content": {
        "promoText": "Kendi nefes pratiği akışını oluştur, birden fazla aşamayı tek bir akıcı seansta birleştir, sesleri ve ipuçlarını ayarla ve rutinlerini başkalarıyla paylaş.",
        "summary": "Vritti, nefes pratiğini sakinlik, odak ve toparlanma için basit bir günlük ritüele dönüştürür.",
        "details": "Nefes egzersizlerini, meditasyon bölümlerini ve ritmik seansları bir araya getirerek kendi akışını oluştur. Önerilen seanslarla hemen başla, süre ve ayarları kendine göre düzenle, sana iyi gelen sesleri seç ve pratiklerini başkalarıyla paylaş. Yeni pratikleri daha hızlı oluşturmak için özel aşamaları şablon olarak kaydet.",
        "features": [
          "Kendi pratik akışlarını oluştur ve oynat",
          "Her pratiği esnek ayarlarla kendine göre şekillendir",
          "Yeni pratikleri daha hızlı oluşturmak için özel aşamaları şablon olarak kaydet",
          "Hazır ve önerilen seanslarla hızlı başla",
          "Sesler, görsel yönlendirmeler ve titreşimlerle daha sürükleyici bir deneyim yaşa",
          "Pratiklerini arkadaşların, öğrencilerin veya danışanlarınla paylaş",
          "Sade ve sezgisel bir arayüzde pratik yap"
        ],
        "closing": "Yeni başlayanlar ve deneyimli uygulayıcılar için.\nDoğu Rehabilitasyon Yöntemleri Enstitüsü'nün metodolojik desteğiyle geliştirilmiştir."
      }
    }
  },
  "zh-CN": {
    "translation": {
      "meta": {
        "appName": "心波",
        "badge": "呼吸练习与调息",
        "dir": "ltr"
      },
      "landing": {
        "heroTitle": "以更平静的方式打造你的呼吸练习。",
        "featuresTitle": "为什么选择 Vritti",
        "galleryTitle": "应用内界面",
        "closingTitle": "用 Vritti 开始你的下一次练习。",
        "languageLabel": "语言",
        "themeLabel": "主题",
        "themeSystem": "自动",
        "themeLight": "浅色",
        "themeDark": "深色",
        "instituteName": "东方康复方法研究所",
        "footerNoteBefore": "在",
        "footerNoteAfter": "的方法学支持下开发。",
        "appStoreBadgeAlt": "在 App Store 下载",
        "googlePlayBadgeAlt": "在 Google Play 获取"
      },
      "freediving": {
        "metaTitle": "Vritti 自由潜 | 干式闭气练习应用",
        "metaDescription": "在陆地上使用 Vritti 进行干式闭气练习。通过灵活计时、提示、提醒、小组件和已保存的例程，创建自定义闭气与呼吸课程。",
        "navLabel": "自由潜页面",
        "navWhy": "为什么有用",
        "navScreenshots": "截图",
        "navPrivacy": "隐私",
        "mainPageCta": "查看 Vritti 主页",
        "heroKicker": "用于干式闭气练习的自由潜应用",
        "heroTitle": "结构化干式闭气练习，简单完成",
        "heroText": "通过灵活计时、提示、提醒、小组件和已保存的例程，创建自定义闭气与呼吸课程。",
        "heroNote": "最适合在陆地上进行干式练习。",
        "whyKicker": "干式练习结构",
        "whyTitle": "为什么自由潜者可能会觉得有用",
        "whyText": "Vritti 是一款灵活的闭气应用和闭气计时器，适用于陆地上的闭气练习，并提供创建可重复干式练习课程的工具。",
        "benefits": [
          "创建自定义多阶段课程",
          "根据自己的干式练习结构调整计时",
          "使用声音、触感和视觉提示",
          "保存例程并持续重复练习",
          "通过小组件和提醒更快开始练习"
        ],
        "featuresKicker": "功能",
        "featuresTitle": "灵活计时和可重复例程",
        "screenshotCaptions": [
          "创建自己的闭气课程",
          "在陆地上进行干式闭气练习",
          "灵活计时和提示",
          "用小组件和提醒保持规律",
          "保存例程以便重复练习",
          "简单界面。精确控制。"
        ],
        "designedTitle": "Vritti 的设计用途",
        "designedText": "Vritti 是一款灵活的呼吸练习应用，可用于陆地上的干式闭气结构和呼吸练习。",
        "notTitle": "它不是什么",
        "notText": "它不能替代教练、水中监督、潜伴流程或自由潜安全训练。",
        "useKicker": "实际用途",
        "useTitle": "可能的使用场景",
        "useCases": [
          "干式闭气计时",
          "练习前的平静呼吸",
          "简单的闭气课程结构",
          "训练间隔中的个人呼吸例程"
        ],
        "trustKicker": "信任",
        "trustTitle": "简单且注重隐私",
        "trustPoints": [
          "可在 iPhone 和 Android 上使用",
          "支持多种界面语言",
          "根据 App Store 页面，不收集数据"
        ],
        "privacyLink": "阅读隐私政策",
        "finalKicker": "可免费试用",
        "finalTitle": "试用 Vritti 进行干式练习",
        "finalText": "如果你想用简单方式在陆地上安排闭气和呼吸课程，可以免费试用 Vritti。",
        "safetyNote": "请仅在陆地上将 Vritti 用于干式练习。它不是自由潜教练、安全系统、水中训练应用，也不能替代指导和潜伴流程。"
      },
      "support": {
        "metaTitle": "Support Vritti | Feedback & Ratings",
        "metaDescription": "Share feedback, rate Vritti, and support the free breathing practice app.",
        "title": "Support Vritti",
        "intro": "Vritti is completely free. If it helps your practice, the best ways to support it are a quick rating, honest feedback — or simply telling a friend.",
        "feedbackTitle": "Send feedback",
        "feedbackIntro": "Found a bug, missing a feature, or just want to say hi? We read every message.",
        "messageLabel": "Your message",
        "messagePlaceholder": "What's on your mind?",
        "emailLabel": "Reply email (optional)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Please enter a valid email address or leave the field empty.",
        "messageRequired": "Please write a message first.",
        "send": "Send feedback",
        "sending": "Sending…",
        "success": "Thank you! Your feedback has been sent.",
        "error": "Could not send feedback right now. Please try again in a few minutes.",
        "rateTitle": "Rate the app",
        "rateIntro": "Ratings help other people find Vritti. It takes less than a minute.",
        "rateAppStore": "Rate on the App Store",
        "rateGooglePlay": "Rate on Google Play",
        "donateTitle": "Leave a donation",
        "donateIntro": "If you'd like to support Vritti's development with a small gift, you can do so below. Everything stays optional — the app is and will remain free.",
        "donateButton": "Support on Ko-fi",
        "backHome": "Back to the main page"
      },
      "content": {
        "promoText": "创建专属呼吸练习流程，将多个阶段整合为一次流畅练习，自定义声音与提示，并与他人分享你的练习。",
        "summary": "Vritti 让呼吸练习成为帮助你放松、专注与恢复状态的简单日常仪式。",
        "details": "你可以把呼吸练习、冥想模块和节奏训练组合成一套流畅的练习流程。从推荐课程开始，灵活调整时长和设置，选择适合当下状态的声音，并把自己的练习分享给他人。将自定义阶段保存为模板，更快创建新的练习。",
        "features": [
          "创建并播放自定义练习序列",
          "用灵活设置打造适合自己的每一次练习",
          "将自定义阶段保存为模板，更快创建新的练习",
          "通过现成和推荐课程快速开始",
          "用声音、视觉和触觉提示带来更沉浸的体验",
          "与朋友、学生或客户分享你的练习",
          "在干净直观的界面中专注练习"
        ],
        "closing": "适合初学者，也适合有经验的练习者。\n在东方康复方法研究所的方法学支持下开发。"
      }
    }
  },
  "zh-TW": {
    "translation": {
      "meta": {
        "appName": "心波",
        "badge": "呼吸練習與調息",
        "dir": "ltr"
      },
      "landing": {
        "heroTitle": "用更平靜的方式打造你的呼吸練習。",
        "featuresTitle": "為什麼選擇 Vritti",
        "galleryTitle": "App 介面",
        "closingTitle": "用 Vritti 開始你的下一次練習。",
        "languageLabel": "語言",
        "themeLabel": "主題",
        "themeSystem": "自動",
        "themeLight": "淺色",
        "themeDark": "深色",
        "instituteName": "東方復健方法研究所",
        "footerNoteBefore": "在",
        "footerNoteAfter": "的方法學支持下開發。",
        "appStoreBadgeAlt": "在 App Store 下載",
        "googlePlayBadgeAlt": "在 Google Play 下載"
      },
      "freediving": {
        "metaTitle": "Vritti 自由潛水 | 乾式閉氣練習 App",
        "metaDescription": "在陸地上使用 Vritti 進行乾式閉氣練習。透過彈性計時、提示、提醒、小工具和已儲存的例程，建立自訂閉氣與呼吸課程。",
        "navLabel": "自由潛水頁面",
        "navWhy": "為什麼有用",
        "navScreenshots": "截圖",
        "navPrivacy": "隱私",
        "mainPageCta": "查看 Vritti 主頁",
        "heroKicker": "用於乾式閉氣練習的自由潛水 App",
        "heroTitle": "結構化乾式閉氣練習，簡單完成",
        "heroText": "透過彈性計時、提示、提醒、小工具和已儲存的例程，建立自訂閉氣與呼吸課程。",
        "heroNote": "最適合在陸地上進行乾式練習。",
        "whyKicker": "乾式練習結構",
        "whyTitle": "為什麼自由潛水者可能會覺得有用",
        "whyText": "Vritti 是一款彈性的閉氣 App 和閉氣計時器，適合在陸地上進行閉氣練習，並提供建立可重複乾式練習課程的工具。",
        "benefits": [
          "建立自訂多階段課程",
          "依照自己的乾式練習結構調整計時",
          "使用聲音、觸覺和視覺提示",
          "儲存例程並穩定重複練習",
          "透過小工具和提醒更快開始練習"
        ],
        "featuresKicker": "功能",
        "featuresTitle": "彈性計時和可重複例程",
        "screenshotCaptions": [
          "建立自己的閉氣課程",
          "在陸地上進行乾式閉氣練習",
          "彈性計時和提示",
          "用小工具和提醒保持規律",
          "儲存例程以便重複練習",
          "簡單介面。精準控制。"
        ],
        "designedTitle": "Vritti 的設計用途",
        "designedText": "Vritti 是一款彈性的呼吸練習 App，可用於陸地上的乾式閉氣結構和呼吸練習。",
        "notTitle": "它不是什麼",
        "notText": "它不能取代教練、水中監督、潛伴流程或自由潛水安全訓練。",
        "useKicker": "實際用途",
        "useTitle": "可能的使用情境",
        "useCases": [
          "乾式閉氣計時",
          "練習前的平靜呼吸",
          "簡單的閉氣課程結構",
          "訓練間隔中的個人呼吸例程"
        ],
        "trustKicker": "信任",
        "trustTitle": "簡單且重視隱私",
        "trustPoints": [
          "可在 iPhone 和 Android 上使用",
          "支援多種介面語言",
          "根據 App Store 頁面，不收集資料"
        ],
        "privacyLink": "閱讀隱私權政策",
        "finalKicker": "可免費試用",
        "finalTitle": "試用 Vritti 進行乾式練習",
        "finalText": "如果你想用簡單方式在陸地上安排閉氣和呼吸課程，可以免費試用 Vritti。",
        "safetyNote": "請僅在陸地上將 Vritti 用於乾式練習。它不是自由潛水教練、安全系統、水中訓練 App，也不能取代指導和潛伴流程。"
      },
      "support": {
        "metaTitle": "Support Vritti | Feedback & Ratings",
        "metaDescription": "Share feedback, rate Vritti, and support the free breathing practice app.",
        "title": "Support Vritti",
        "intro": "Vritti is completely free. If it helps your practice, the best ways to support it are a quick rating, honest feedback — or simply telling a friend.",
        "feedbackTitle": "Send feedback",
        "feedbackIntro": "Found a bug, missing a feature, or just want to say hi? We read every message.",
        "messageLabel": "Your message",
        "messagePlaceholder": "What's on your mind?",
        "emailLabel": "Reply email (optional)",
        "emailPlaceholder": "you@example.com",
        "emailInvalid": "Please enter a valid email address or leave the field empty.",
        "messageRequired": "Please write a message first.",
        "send": "Send feedback",
        "sending": "Sending…",
        "success": "Thank you! Your feedback has been sent.",
        "error": "Could not send feedback right now. Please try again in a few minutes.",
        "rateTitle": "Rate the app",
        "rateIntro": "Ratings help other people find Vritti. It takes less than a minute.",
        "rateAppStore": "Rate on the App Store",
        "rateGooglePlay": "Rate on Google Play",
        "donateTitle": "Leave a donation",
        "donateIntro": "If you'd like to support Vritti's development with a small gift, you can do so below. Everything stays optional — the app is and will remain free.",
        "donateButton": "Support on Ko-fi",
        "backHome": "Back to the main page"
      },
      "content": {
        "promoText": "建立專屬呼吸練習流程，將多個階段整合成一次流暢練習，自訂聲音與提示，並與他人分享你的練習。",
        "summary": "Vritti 讓呼吸練習成為幫助你放鬆、專注與恢復狀態的簡單日常儀式。",
        "details": "你可以把呼吸練習、冥想模組和節奏訓練組合成一套流暢的練習流程。從推薦課程開始，彈性調整時間與設定，選擇適合當下狀態的聲音，並把自己的練習分享給其他人。將自訂階段儲存為範本，更快建立新的練習。",
        "features": [
          "建立並播放自訂練習序列",
          "用彈性設定打造適合自己的每一次練習",
          "將自訂階段儲存為範本，更快建立新的練習",
          "透過現成與推薦課程快速開始",
          "用聲音、視覺與觸覺提示帶來更沉浸的體驗",
          "與朋友、學生或客戶分享你的練習",
          "在乾淨直觀的介面中專注練習"
        ],
        "closing": "適合初學者，也適合有經驗的練習者。\n在東方復健方法研究所的方法學支持下開發。"
      }
    }
  }
} as const;

export type SupportedLocale = keyof typeof resources;
